import _toConsumableArray from "/home/circleci/project/workspaces/frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _get from "/home/circleci/project/workspaces/frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/get";
import _getPrototypeOf from "/home/circleci/project/workspaces/frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/home/circleci/project/workspaces/frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/home/circleci/project/workspaces/frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";
import _slicedToArray from "/home/circleci/project/workspaces/frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _createForOfIteratorHelper from "/home/circleci/project/workspaces/frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper";
import _classCallCheck from "/home/circleci/project/workspaces/frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/circleci/project/workspaces/frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _babelRuntimeHelpersEsmExtends from "@babel/runtime/helpers/esm/extends";
import _babelRuntimeHelpersEsmClassPrivateFieldLooseKey from "@babel/runtime/helpers/esm/classPrivateFieldLooseKey";
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */
// Data from https://github.com/unicode-cldr/cldr-core/blob/master/supplemental/weekData.json
// Locales starting on Sunday have been removed for compression.

var $a895780b391a18bdc653c6a504739e8$export$weekStartData = {
  '001': 1,
  AD: 1,
  AE: 6,
  AF: 6,
  AI: 1,
  AL: 1,
  AM: 1,
  AN: 1,
  AT: 1,
  AX: 1,
  AZ: 1,
  BA: 1,
  BE: 1,
  BG: 1,
  BH: 6,
  BM: 1,
  BN: 1,
  BY: 1,
  CH: 1,
  CL: 1,
  CM: 1,
  CR: 1,
  CY: 1,
  CZ: 1,
  DE: 1,
  DJ: 6,
  DK: 1,
  DZ: 6,
  EC: 1,
  EE: 1,
  EG: 6,
  ES: 1,
  FI: 1,
  FJ: 1,
  FO: 1,
  FR: 1,
  GB: 1,
  GE: 1,
  GF: 1,
  GP: 1,
  GR: 1,
  HR: 1,
  HU: 1,
  IE: 1,
  IQ: 6,
  IR: 6,
  IS: 1,
  IT: 1,
  JO: 6,
  KG: 1,
  KW: 6,
  KZ: 1,
  LB: 1,
  LI: 1,
  LK: 1,
  LT: 1,
  LU: 1,
  LV: 1,
  LY: 6,
  MC: 1,
  MD: 1,
  ME: 1,
  MK: 1,
  MN: 1,
  MQ: 1,
  MV: 5,
  MY: 1,
  NL: 1,
  NO: 1,
  NZ: 1,
  OM: 6,
  PL: 1,
  QA: 6,
  RE: 1,
  RO: 1,
  RS: 1,
  RU: 1,
  SD: 6,
  SE: 1,
  SI: 1,
  SK: 1,
  SM: 1,
  SY: 6,
  TJ: 1,
  TM: 1,
  TR: 1,
  UA: 1,
  UY: 1,
  UZ: 1,
  VA: 1,
  VN: 1,
  XK: 1
};
export function isSameDay(a, b) {
  b = toCalendar(b, a.calendar);
  return a.era === b.era && a.year === b.year && a.month === b.month && a.day === b.day;
}
export function isSameMonth(a, b) {
  b = toCalendar(b, a.calendar); // In the Japanese calendar, months can span multiple eras/years, so only compare the first of the month.

  a = startOfMonth(a);
  b = startOfMonth(b);
  return a.era === b.era && a.year === b.year && a.month === b.month;
}
export function isSameYear(a, b) {
  b = toCalendar(b, a.calendar);
  a = startOfYear(a);
  b = startOfYear(b);
  return a.era === b.era && a.year === b.year;
}
export function isEqualDay(a, b) {
  return a.calendar.identifier === b.calendar.identifier && a.era === b.era && a.year === b.year && a.month === b.month && a.day === b.day;
}
export function isEqualMonth(a, b) {
  a = startOfMonth(a);
  b = startOfMonth(b);
  return a.calendar.identifier === b.calendar.identifier && a.era === b.era && a.year === b.year && a.month === b.month;
}
export function isEqualYear(a, b) {
  a = startOfYear(a);
  b = startOfYear(b);
  return a.calendar.identifier === b.calendar.identifier && a.era === b.era && a.year === b.year;
}
export function isToday(date, timeZone) {
  return isSameDay(date, today(timeZone));
}
export function getDayOfWeek(date, locale) {
  var julian = date.calendar.toJulianDay(date); // If julian is negative, then julian % 7 will be negative, so we adjust
  // accordingly.  Julian day 0 is Monday.

  var dayOfWeek = Math.ceil(julian + 1 - $e027b4c65f8a8a64bf868330c10585e$var$getWeekStart(locale)) % 7;

  if (dayOfWeek < 0) {
    dayOfWeek += 7;
  }

  return dayOfWeek;
}
export function now(timeZone) {
  return fromAbsolute(Date.now(), timeZone);
}
export function today(timeZone) {
  return toCalendarDate(now(timeZone));
}
export function compareDate(a, b) {
  return a.calendar.toJulianDay(a) - b.calendar.toJulianDay(b);
}
export function compareTime(a, b) {
  return $e027b4c65f8a8a64bf868330c10585e$var$timeToMs(a) - $e027b4c65f8a8a64bf868330c10585e$var$timeToMs(b);
}

function $e027b4c65f8a8a64bf868330c10585e$var$timeToMs(a) {
  return a.hour * 60 * 60 * 1000 + a.minute * 60 * 1000 + a.second * 1000 + a.millisecond;
}

export function getHoursInDay(a, timeZone) {
  var ms = toAbsolute(a, timeZone);
  var tomorrow = a.add({
    days: 1
  });
  var tomorrowMs = toAbsolute(tomorrow, timeZone);
  return (tomorrowMs - ms) / 3600000;
}
var $e027b4c65f8a8a64bf868330c10585e$var$localTimeZone = null;
export function getLocalTimeZone() {
  // TODO: invalidate this somehow?
  if ($e027b4c65f8a8a64bf868330c10585e$var$localTimeZone == null) {
    $e027b4c65f8a8a64bf868330c10585e$var$localTimeZone = new Intl.DateTimeFormat().resolvedOptions().timeZone;
  }

  return $e027b4c65f8a8a64bf868330c10585e$var$localTimeZone;
}
export function startOfMonth(date) {
  // Use `subtract` instead of `set` so we don't get constrained in an era.
  return date.subtract({
    days: date.day - 1
  });
}
export function endOfMonth(date) {
  return date.add({
    days: date.calendar.getDaysInMonth(date) - date.day
  });
}
export function startOfYear(date) {
  return startOfMonth(date.subtract({
    months: date.month - 1
  }));
}
export function endOfYear(date) {
  return endOfMonth(date.add({
    months: date.calendar.getMonthsInYear(date) - date.month
  }));
}
export function getMinimumMonthInYear(date) {
  if (date.calendar.getMinimumMonthInYear) {
    return date.calendar.getMinimumMonthInYear(date);
  }

  return 1;
}
export function getMinimumDayInMonth(date) {
  if (date.calendar.getMinimumDayInMonth) {
    return date.calendar.getMinimumDayInMonth(date);
  }

  return 1;
}
export function startOfWeek(date, locale) {
  var dayOfWeek = getDayOfWeek(date, locale);
  return date.subtract({
    days: dayOfWeek
  });
}
export function endOfWeek(date, locale) {
  return startOfWeek(date, locale).add({
    days: 6
  });
}
var $e027b4c65f8a8a64bf868330c10585e$var$cachedRegions = new Map();

function $e027b4c65f8a8a64bf868330c10585e$var$getRegion(locale) {
  // If the Intl.Locale API is available, use it to get the region for the locale.
  // @ts-ignore
  if (Intl.Locale) {
    // Constructing an Intl.Locale is expensive, so cache the result.
    var region = $e027b4c65f8a8a64bf868330c10585e$var$cachedRegions.get(locale);

    if (!region) {
      // @ts-ignore
      region = new Intl.Locale(locale).maximize().region;
      $e027b4c65f8a8a64bf868330c10585e$var$cachedRegions.set(locale, region);
    }

    return region;
  } // If not, just try splitting the string.
  // If the second part of the locale string is 'u',
  // then this is a unicode extension, so ignore it.
  // Otherwise, it should be the region.


  var part = locale.split('-')[1];
  return part === 'u' ? null : part;
}

function $e027b4c65f8a8a64bf868330c10585e$var$getWeekStart(locale) {
  // TODO: use Intl.Locale for this once browsers support the weekInfo property
  // https://github.com/tc39/proposal-intl-locale-info
  var region = $e027b4c65f8a8a64bf868330c10585e$var$getRegion(locale);
  return $a895780b391a18bdc653c6a504739e8$export$weekStartData[region] || 0;
}

export function getWeeksInMonth(date, locale) {
  var days = date.calendar.getDaysInMonth(date);
  return Math.ceil((getDayOfWeek(startOfMonth(date), locale) + days) / 7);
}
export function minDate(a, b) {
  return a.compare(b) <= 0 ? a : b;
}
export function maxDate(a, b) {
  return a.compare(b) >= 0 ? a : b;
}

function $e69ae7432d03ee6ff5aa642daa3d5d3$export$mod(amount, numerator) {
  return amount - numerator * Math.floor(amount / numerator);
}

var $d9ab185420a4ffb38f7504d41a330b3a$var$EPOCH = 1721426; // 001/01/03 Julian C.E.

function $d9ab185420a4ffb38f7504d41a330b3a$export$gregorianToJulianDay(year, month, day) {
  var y1 = year - 1;
  var monthOffset = -2;

  if (month <= 2) {
    monthOffset = 0;
  } else if ($d9ab185420a4ffb38f7504d41a330b3a$export$isLeapYear(year)) {
    monthOffset = -1;
  }

  return $d9ab185420a4ffb38f7504d41a330b3a$var$EPOCH - 1 + 365 * y1 + Math.floor(y1 / 4) - Math.floor(y1 / 100) + Math.floor(y1 / 400) + Math.floor((367 * month - 362) / 12 + monthOffset + day);
}

function $d9ab185420a4ffb38f7504d41a330b3a$export$isLeapYear(year) {
  return year % 4 === 0 && (year % 100 !== 0 || year % 400 === 0);
}

var $d9ab185420a4ffb38f7504d41a330b3a$var$daysInMonth = {
  standard: [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31],
  leapyear: [31, 29, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31]
};
export var GregorianCalendar = /*#__PURE__*/function () {
  function GregorianCalendar() {
    _classCallCheck(this, GregorianCalendar);

    this.identifier = 'gregory';
  }

  _createClass(GregorianCalendar, [{
    key: "fromJulianDay",
    value: function fromJulianDay(jd) {
      var jd0 = jd;
      var depoch = jd0 - $d9ab185420a4ffb38f7504d41a330b3a$var$EPOCH;
      var quadricent = Math.floor(depoch / 146097);
      var dqc = $e69ae7432d03ee6ff5aa642daa3d5d3$export$mod(depoch, 146097);
      var cent = Math.floor(dqc / 36524);
      var dcent = $e69ae7432d03ee6ff5aa642daa3d5d3$export$mod(dqc, 36524);
      var quad = Math.floor(dcent / 1461);
      var dquad = $e69ae7432d03ee6ff5aa642daa3d5d3$export$mod(dcent, 1461);
      var yindex = Math.floor(dquad / 365);
      var year = quadricent * 400 + cent * 100 + quad * 4 + yindex + (cent !== 4 && yindex !== 4 ? 1 : 0);
      var yearDay = jd0 - $d9ab185420a4ffb38f7504d41a330b3a$export$gregorianToJulianDay(year, 1, 1);
      var leapAdj = 2;

      if (jd0 < $d9ab185420a4ffb38f7504d41a330b3a$export$gregorianToJulianDay(year, 3, 1)) {
        leapAdj = 0;
      } else if ($d9ab185420a4ffb38f7504d41a330b3a$export$isLeapYear(year)) {
        leapAdj = 1;
      }

      var month = Math.floor(((yearDay + leapAdj) * 12 + 373) / 367);
      var day = jd0 - $d9ab185420a4ffb38f7504d41a330b3a$export$gregorianToJulianDay(year, month, 1) + 1;
      return new CalendarDate(this, year, month, day);
    }
  }, {
    key: "toJulianDay",
    value: function toJulianDay(date) {
      return $d9ab185420a4ffb38f7504d41a330b3a$export$gregorianToJulianDay(date.year, date.month, date.day);
    }
  }, {
    key: "getDaysInMonth",
    value: function getDaysInMonth(date) {
      return $d9ab185420a4ffb38f7504d41a330b3a$var$daysInMonth[$d9ab185420a4ffb38f7504d41a330b3a$export$isLeapYear(date.year) ? 'leapyear' : 'standard'][date.month - 1];
    } // eslint-disable-next-line @typescript-eslint/no-unused-vars

  }, {
    key: "getMonthsInYear",
    value: function getMonthsInYear(date) {
      return 12;
    }
  }, {
    key: "getDaysInYear",
    value: function getDaysInYear(date) {
      return $d9ab185420a4ffb38f7504d41a330b3a$export$isLeapYear(date.year) ? 366 : 365;
    } // eslint-disable-next-line @typescript-eslint/no-unused-vars

  }, {
    key: "getYearsInEra",
    value: function getYearsInEra(date) {
      return 9999;
    }
  }, {
    key: "getEras",
    value: function getEras() {
      return ['BC', 'AD'];
    }
  }, {
    key: "getYearsToAdd",
    value: function getYearsToAdd(date, years) {
      return date.era === 'BC' ? -years : years;
    }
  }, {
    key: "balanceDate",
    value: function balanceDate(date) {
      if (date.year <= 0) {
        date.era = date.era === 'BC' ? 'AD' : 'BC';
        date.year = 1 - date.year;
      }
    }
  }]);

  return GregorianCalendar;
}();
export function epochFromDate(date) {
  date = toCalendar(date, new GregorianCalendar());
  return $a44339c76f31b4f380c2753cbb9f3$var$epochFromParts(date.year, date.month, date.day, date.hour, date.minute, date.second, date.millisecond);
}

function $a44339c76f31b4f380c2753cbb9f3$var$epochFromParts(year, month, day, hour, minute, second, millisecond) {
  // Note: Date.UTC() interprets one and two-digit years as being in the
  // 20th century, so don't use it
  var date = new Date();
  date.setUTCHours(hour, minute, second, millisecond);
  date.setUTCFullYear(year, month - 1, day);
  return date.getTime();
}

export function getTimeZoneOffset(ms, timeZone) {
  // Fast path: for local timezone, use native Date.
  if (timeZone === getLocalTimeZone()) {
    return new Date(ms).getTimezoneOffset() * -60 * 1000;
  }

  var _$a44339c76f31b4f380c = $a44339c76f31b4f380c2753cbb9f3$var$getTimeZoneParts(ms, timeZone),
      year = _$a44339c76f31b4f380c.year,
      month = _$a44339c76f31b4f380c.month,
      day = _$a44339c76f31b4f380c.day,
      hour = _$a44339c76f31b4f380c.hour,
      minute = _$a44339c76f31b4f380c.minute,
      second = _$a44339c76f31b4f380c.second;

  var utc = $a44339c76f31b4f380c2753cbb9f3$var$epochFromParts(year, month, day, hour, minute, second, 0);
  return utc - Math.floor(ms / 1000) * 1000;
}
var $a44339c76f31b4f380c2753cbb9f3$var$formattersByTimeZone = new Map();

function $a44339c76f31b4f380c2753cbb9f3$var$getTimeZoneParts(ms, timeZone) {
  var formatter = $a44339c76f31b4f380c2753cbb9f3$var$formattersByTimeZone.get(timeZone);

  if (!formatter) {
    formatter = new Intl.DateTimeFormat('en-US', {
      timeZone: timeZone,
      hour12: false,
      era: 'short',
      year: 'numeric',
      month: 'numeric',
      day: 'numeric',
      hour: 'numeric',
      minute: 'numeric',
      second: 'numeric'
    });
    $a44339c76f31b4f380c2753cbb9f3$var$formattersByTimeZone.set(timeZone, formatter);
  }

  var parts = formatter.formatToParts(new Date(ms));
  var namedParts = {};

  var _iterator = _createForOfIteratorHelper(parts),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var part = _step.value;

      if (part.type !== 'literal') {
        namedParts[part.type] = part.value;
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  return {
    year: namedParts.era === 'BC' ? -namedParts.year + 1 : +namedParts.year,
    month: +namedParts.month,
    day: +namedParts.day,
    hour: namedParts.hour === '24' ? 0 : +namedParts.hour,
    // bugs.chromium.org/p/chromium/issues/detail?id=1045791
    minute: +namedParts.minute,
    second: +namedParts.second
  };
}

var $a44339c76f31b4f380c2753cbb9f3$var$DAYMILLIS = 86400000;
export function possibleAbsolutes(date, timeZone) {
  var ms = epochFromDate(date);
  var earlier = ms - getTimeZoneOffset(ms - $a44339c76f31b4f380c2753cbb9f3$var$DAYMILLIS, timeZone);
  var later = ms - getTimeZoneOffset(ms + $a44339c76f31b4f380c2753cbb9f3$var$DAYMILLIS, timeZone);
  return $a44339c76f31b4f380c2753cbb9f3$var$getValidWallTimes(date, timeZone, earlier, later);
}

function $a44339c76f31b4f380c2753cbb9f3$var$getValidWallTimes(date, timeZone, earlier, later) {
  var found = earlier === later ? [earlier] : [earlier, later];
  return found.filter(function (absolute) {
    return $a44339c76f31b4f380c2753cbb9f3$var$isValidWallTime(date, timeZone, absolute);
  });
}

function $a44339c76f31b4f380c2753cbb9f3$var$isValidWallTime(date, timeZone, absolute) {
  var parts = $a44339c76f31b4f380c2753cbb9f3$var$getTimeZoneParts(absolute, timeZone);
  return date.year === parts.year && date.month === parts.month && date.day === parts.day && date.hour === parts.hour && date.minute === parts.minute && date.second === parts.second;
}

export function toAbsolute(date, timeZone, disambiguation) {
  if (disambiguation === void 0) {
    disambiguation = 'compatible';
  }

  var dateTime = toCalendarDateTime(date); // Fast path: if the time zone is the local timezone and disambiguation is compatible, use native Date.

  if (timeZone === getLocalTimeZone() && disambiguation === 'compatible') {
    dateTime = toCalendar(dateTime, new GregorianCalendar()); // Don't use Date constructor here because two-digit years are interpreted in the 20th century.

    var _date = new Date();

    _date.setFullYear(dateTime.year, dateTime.month - 1, dateTime.day);

    _date.setHours(dateTime.hour, dateTime.minute, dateTime.second, dateTime.millisecond);

    return _date.getTime();
  }

  var ms = epochFromDate(dateTime);
  var offsetBefore = getTimeZoneOffset(ms - $a44339c76f31b4f380c2753cbb9f3$var$DAYMILLIS, timeZone);
  var offsetAfter = getTimeZoneOffset(ms + $a44339c76f31b4f380c2753cbb9f3$var$DAYMILLIS, timeZone);
  var valid = $a44339c76f31b4f380c2753cbb9f3$var$getValidWallTimes(dateTime, timeZone, ms - offsetBefore, ms - offsetAfter);

  if (valid.length === 1) {
    return valid[0];
  }

  if (valid.length > 1) {
    switch (disambiguation) {
      // 'compatible' means 'earlier' for "fall back" transitions
      case 'compatible':
      case 'earlier':
        return valid[0];

      case 'later':
        return valid[valid.length - 1];

      case 'reject':
        throw new RangeError('Multiple possible absolute times found');
    }
  }

  switch (disambiguation) {
    case 'earlier':
      return Math.min(ms - offsetBefore, ms - offsetAfter);
    // 'compatible' means 'later' for "spring forward" transitions

    case 'compatible':
    case 'later':
      return Math.max(ms - offsetBefore, ms - offsetAfter);

    case 'reject':
      throw new RangeError('No such absolute time found');
  }
}

function _toDate(dateTime, timeZone, disambiguation) {
  if (disambiguation === void 0) {
    disambiguation = 'compatible';
  }

  return new Date(toAbsolute(dateTime, timeZone, disambiguation));
}

export { _toDate as toDate };
export function fromAbsolute(ms, timeZone) {
  var offset = getTimeZoneOffset(ms, timeZone);
  var date = new Date(ms + offset);
  var year = date.getUTCFullYear();
  var month = date.getUTCMonth() + 1;
  var day = date.getUTCDate();
  var hour = date.getUTCHours();
  var minute = date.getUTCMinutes();
  var second = date.getUTCSeconds();
  var millisecond = date.getUTCMilliseconds();
  return new ZonedDateTime(year, month, day, timeZone, offset, hour, minute, second, millisecond);
}
export function fromDate(date, timeZone) {
  return fromAbsolute(date.getTime(), timeZone);
}
export function fromDateToLocal(date) {
  return fromDate(date, getLocalTimeZone());
}
export function toCalendarDate(dateTime) {
  return new CalendarDate(dateTime.calendar, dateTime.era, dateTime.year, dateTime.month, dateTime.day);
}
export function toDateFields(date) {
  return {
    era: date.era,
    year: date.year,
    month: date.month,
    day: date.day
  };
}
export function toTimeFields(date) {
  return {
    hour: date.hour,
    minute: date.minute,
    second: date.second,
    millisecond: date.millisecond
  };
}
export function toCalendarDateTime(date, time) {
  var hour = 0,
      minute = 0,
      second = 0,
      millisecond = 0;

  if ('timeZone' in date) {
    hour = date.hour;
    minute = date.minute;
    second = date.second;
    millisecond = date.millisecond;
  } else if ('hour' in date && !time) {
    return date;
  }

  if (time) {
    hour = time.hour;
    minute = time.minute;
    second = time.second;
    millisecond = time.millisecond;
  }

  return new CalendarDateTime(date.calendar, date.era, date.year, date.month, date.day, hour, minute, second, millisecond);
}
export function toTime(dateTime) {
  return new Time(dateTime.hour, dateTime.minute, dateTime.second, dateTime.millisecond);
}
export function toCalendar(date, calendar) {
  if (date.calendar.identifier === calendar.identifier) {
    return date;
  }

  var calendarDate = calendar.fromJulianDay(date.calendar.toJulianDay(date));
  var copy = date.copy();
  copy.calendar = calendar;
  copy.era = calendarDate.era;
  copy.year = calendarDate.year;
  copy.month = calendarDate.month;
  copy.day = calendarDate.day;
  return copy;
}
export function toZoned(date, timeZone, disambiguation) {
  if (date instanceof ZonedDateTime) {
    if (date.timeZone === timeZone) {
      return date;
    }

    return toTimeZone(date, timeZone);
  }

  var ms = toAbsolute(date, timeZone, disambiguation);
  return fromAbsolute(ms, timeZone);
}
export function zonedToDate(date) {
  var ms = epochFromDate(date) - date.offset;
  return new Date(ms);
}
export function toTimeZone(date, timeZone) {
  var ms = epochFromDate(date) - date.offset;
  return toCalendar(fromAbsolute(ms, timeZone), date.calendar);
}
export function toLocalTimeZone(date) {
  return toTimeZone(date, getLocalTimeZone());
}
var $bacf9a69bf9753afe9f94cd9dd8aa2ad$var$ONE_HOUR = 3600000;

function $bacf9a69bf9753afe9f94cd9dd8aa2ad$export$add(date, duration) {
  var mutableDate = date.copy();
  var days = 'hour' in date ? $bacf9a69bf9753afe9f94cd9dd8aa2ad$var$addTimeFields(date, duration) : 0;
  $bacf9a69bf9753afe9f94cd9dd8aa2ad$var$addYears(mutableDate, duration.years || 0);

  if (mutableDate.calendar.balanceYearMonth) {
    mutableDate.calendar.balanceYearMonth(mutableDate, date);
  }

  mutableDate.month += duration.months || 0;
  $bacf9a69bf9753afe9f94cd9dd8aa2ad$var$balanceYearMonth(mutableDate);
  $bacf9a69bf9753afe9f94cd9dd8aa2ad$var$constrainMonthDay(mutableDate);
  mutableDate.day += (duration.weeks || 0) * 7;
  mutableDate.day += duration.days || 0;
  mutableDate.day += days;
  $bacf9a69bf9753afe9f94cd9dd8aa2ad$var$balanceDay(mutableDate);

  if (mutableDate.calendar.balanceDate) {
    mutableDate.calendar.balanceDate(mutableDate);
  }

  return mutableDate;
}

function $bacf9a69bf9753afe9f94cd9dd8aa2ad$var$addYears(date, years) {
  if (date.calendar.getYearsToAdd) {
    years = date.calendar.getYearsToAdd(date, years);
  }

  date.year += years;
}

function $bacf9a69bf9753afe9f94cd9dd8aa2ad$var$balanceYearMonth(date) {
  while (date.month < 1) {
    $bacf9a69bf9753afe9f94cd9dd8aa2ad$var$addYears(date, -1);
    date.month += date.calendar.getMonthsInYear(date);
  }

  var monthsInYear = 0;

  while (date.month > (monthsInYear = date.calendar.getMonthsInYear(date))) {
    date.month -= monthsInYear;
    $bacf9a69bf9753afe9f94cd9dd8aa2ad$var$addYears(date, 1);
  }
}

function $bacf9a69bf9753afe9f94cd9dd8aa2ad$var$balanceDay(date) {
  while (date.day < 1) {
    date.month--;
    $bacf9a69bf9753afe9f94cd9dd8aa2ad$var$balanceYearMonth(date);
    date.day += date.calendar.getDaysInMonth(date);
  }

  while (date.day > date.calendar.getDaysInMonth(date)) {
    date.day -= date.calendar.getDaysInMonth(date);
    date.month++;
    $bacf9a69bf9753afe9f94cd9dd8aa2ad$var$balanceYearMonth(date);
  }
}

function $bacf9a69bf9753afe9f94cd9dd8aa2ad$var$constrainMonthDay(date) {
  date.month = Math.max(1, Math.min(date.calendar.getMonthsInYear(date), date.month));
  date.day = Math.max(1, Math.min(date.calendar.getDaysInMonth(date), date.day));
}

function $bacf9a69bf9753afe9f94cd9dd8aa2ad$export$constrain(date) {
  if (date.calendar.constrainDate) {
    date.calendar.constrainDate(date);
  }

  date.year = Math.max(1, Math.min(date.calendar.getYearsInEra(date), date.year));
  $bacf9a69bf9753afe9f94cd9dd8aa2ad$var$constrainMonthDay(date);
}

function $bacf9a69bf9753afe9f94cd9dd8aa2ad$export$invertDuration(duration) {
  var inverseDuration = {};

  for (var key in duration) {
    if (typeof duration[key] === 'number') {
      inverseDuration[key] = -duration[key];
    }
  }

  return inverseDuration;
}

function $bacf9a69bf9753afe9f94cd9dd8aa2ad$export$subtract(date, duration) {
  return $bacf9a69bf9753afe9f94cd9dd8aa2ad$export$add(date, $bacf9a69bf9753afe9f94cd9dd8aa2ad$export$invertDuration(duration));
}

function $bacf9a69bf9753afe9f94cd9dd8aa2ad$export$set(date, fields) {
  var mutableDate = date.copy();

  if (fields.era != null) {
    mutableDate.era = fields.era;
  }

  if (fields.year != null) {
    mutableDate.year = fields.year;
  }

  if (fields.month != null) {
    mutableDate.month = fields.month;
  }

  if (fields.day != null) {
    mutableDate.day = fields.day;
  }

  $bacf9a69bf9753afe9f94cd9dd8aa2ad$export$constrain(mutableDate);
  return mutableDate;
}

function $bacf9a69bf9753afe9f94cd9dd8aa2ad$export$setTime(value, fields) {
  var mutableValue = value.copy();

  if (fields.hour != null) {
    mutableValue.hour = fields.hour;
  }

  if (fields.minute != null) {
    mutableValue.minute = fields.minute;
  }

  if (fields.second != null) {
    mutableValue.second = fields.second;
  }

  if (fields.millisecond != null) {
    mutableValue.millisecond = fields.millisecond;
  }

  $bacf9a69bf9753afe9f94cd9dd8aa2ad$export$constrainTime(mutableValue);
  return mutableValue;
}

function $bacf9a69bf9753afe9f94cd9dd8aa2ad$var$balanceTime(time) {
  time.second += Math.floor(time.millisecond / 1000);
  time.millisecond = $bacf9a69bf9753afe9f94cd9dd8aa2ad$var$nonNegativeMod(time.millisecond, 1000);
  time.minute += Math.floor(time.second / 60);
  time.second = $bacf9a69bf9753afe9f94cd9dd8aa2ad$var$nonNegativeMod(time.second, 60);
  time.hour += Math.floor(time.minute / 60);
  time.minute = $bacf9a69bf9753afe9f94cd9dd8aa2ad$var$nonNegativeMod(time.minute, 60);
  var days = Math.floor(time.hour / 24);
  time.hour = $bacf9a69bf9753afe9f94cd9dd8aa2ad$var$nonNegativeMod(time.hour, 24);
  return days;
}

function $bacf9a69bf9753afe9f94cd9dd8aa2ad$export$constrainTime(time) {
  time.millisecond = Math.max(0, Math.min(time.millisecond, 1000));
  time.second = Math.max(0, Math.min(time.second, 59));
  time.minute = Math.max(0, Math.min(time.minute, 59));
  time.hour = Math.max(0, Math.min(time.hour, 23));
}

function $bacf9a69bf9753afe9f94cd9dd8aa2ad$var$nonNegativeMod(a, b) {
  var result = a % b;

  if (result < 0) {
    result += b;
  }

  return result;
}

function $bacf9a69bf9753afe9f94cd9dd8aa2ad$var$addTimeFields(time, duration) {
  time.hour += duration.hours || 0;
  time.minute += duration.minutes || 0;
  time.second += duration.seconds || 0;
  time.millisecond += duration.milliseconds || 0;
  return $bacf9a69bf9753afe9f94cd9dd8aa2ad$var$balanceTime(time);
}

function $bacf9a69bf9753afe9f94cd9dd8aa2ad$export$addTime(time, duration) {
  var res = time.copy();
  $bacf9a69bf9753afe9f94cd9dd8aa2ad$var$addTimeFields(res, duration);
  return res;
}

function $bacf9a69bf9753afe9f94cd9dd8aa2ad$export$subtractTime(time, duration) {
  return $bacf9a69bf9753afe9f94cd9dd8aa2ad$export$addTime(time, $bacf9a69bf9753afe9f94cd9dd8aa2ad$export$invertDuration(duration));
}

function $bacf9a69bf9753afe9f94cd9dd8aa2ad$export$cycleDate(value, field, amount, options) {
  var mutable = value.copy();

  switch (field) {
    case 'era':
      {
        var eras = value.calendar.getEras();
        var eraIndex = eras.indexOf(value.era);

        if (eraIndex < 0) {
          throw new Error('Invalid era: ' + value.era);
        }

        eraIndex = $bacf9a69bf9753afe9f94cd9dd8aa2ad$var$cycleValue(eraIndex, amount, 0, eras.length - 1, options == null ? void 0 : options.round);
        mutable.era = eras[eraIndex]; // Constrain the year and other fields within the era, so the era doesn't change when we balance below.

        $bacf9a69bf9753afe9f94cd9dd8aa2ad$export$constrain(mutable);
        break;
      }

    case 'year':
      {
        if (mutable.calendar.getYearsToAdd) {
          amount = mutable.calendar.getYearsToAdd(mutable, amount);
        } // The year field should not cycle within the era as that can cause weird behavior affecting other fields.
        // We need to also allow values < 1 so that decrementing goes to the previous era. If we get -Infinity back
        // we know we wrapped around after reaching 9999 (the maximum), so set the year back to 1.


        mutable.year = $bacf9a69bf9753afe9f94cd9dd8aa2ad$var$cycleValue(value.year, amount, -Infinity, 9999, options == null ? void 0 : options.round);

        if (mutable.year === -Infinity) {
          mutable.year = 1;
        }

        if (mutable.calendar.balanceYearMonth) {
          mutable.calendar.balanceYearMonth(mutable, value);
        }

        break;
      }

    case 'month':
      mutable.month = $bacf9a69bf9753afe9f94cd9dd8aa2ad$var$cycleValue(value.month, amount, 1, value.calendar.getMonthsInYear(value), options == null ? void 0 : options.round);
      break;

    case 'day':
      mutable.day = $bacf9a69bf9753afe9f94cd9dd8aa2ad$var$cycleValue(value.day, amount, 1, value.calendar.getDaysInMonth(value), options == null ? void 0 : options.round);
      break;

    default:
      throw new Error('Unsupported field ' + field);
  }

  if (value.calendar.balanceDate) {
    value.calendar.balanceDate(mutable);
  }

  $bacf9a69bf9753afe9f94cd9dd8aa2ad$export$constrain(mutable);
  return mutable;
}

function $bacf9a69bf9753afe9f94cd9dd8aa2ad$export$cycleTime(value, field, amount, options) {
  var mutable = value.copy();

  switch (field) {
    case 'hour':
      {
        var hours = value.hour;
        var min = 0;
        var max = 23;

        if ((options == null ? void 0 : options.hourCycle) === 12) {
          var isPM = hours >= 12;
          min = isPM ? 12 : 0;
          max = isPM ? 23 : 11;
        }

        mutable.hour = $bacf9a69bf9753afe9f94cd9dd8aa2ad$var$cycleValue(hours, amount, min, max, options == null ? void 0 : options.round);
        break;
      }

    case 'minute':
      mutable.minute = $bacf9a69bf9753afe9f94cd9dd8aa2ad$var$cycleValue(value.minute, amount, 0, 59, options == null ? void 0 : options.round);
      break;

    case 'second':
      mutable.second = $bacf9a69bf9753afe9f94cd9dd8aa2ad$var$cycleValue(value.second, amount, 0, 59, options == null ? void 0 : options.round);
      break;

    case 'millisecond':
      mutable.millisecond = $bacf9a69bf9753afe9f94cd9dd8aa2ad$var$cycleValue(value.millisecond, amount, 0, 999, options == null ? void 0 : options.round);
      break;

    default:
      throw new Error('Unsupported field ' + field);
  }

  return mutable;
}

function $bacf9a69bf9753afe9f94cd9dd8aa2ad$var$cycleValue(value, amount, min, max, round) {
  if (round === void 0) {
    round = false;
  }

  if (round) {
    value += Math.sign(amount);

    if (value < min) {
      value = max;
    }

    var div = Math.abs(amount);

    if (amount > 0) {
      value = Math.ceil(value / div) * div;
    } else {
      value = Math.floor(value / div) * div;
    }

    if (value > max) {
      value = min;
    }
  } else {
    value += amount;

    if (value < min) {
      value = max - (min - value - 1);
    } else if (value > max) {
      value = min + (value - max - 1);
    }
  }

  return value;
}

function $bacf9a69bf9753afe9f94cd9dd8aa2ad$export$addZoned(dateTime, duration) {
  var ms;

  if (duration.years != null && duration.years !== 0 || duration.months != null && duration.months !== 0 || duration.days != null && duration.days !== 0) {
    var _res = $bacf9a69bf9753afe9f94cd9dd8aa2ad$export$add(toCalendarDateTime(dateTime), {
      years: duration.years,
      months: duration.months,
      days: duration.days
    }); // Changing the date may change the timezone offset, so we need to recompute
    // using the 'compatible' disambiguation.


    ms = toAbsolute(_res, dateTime.timeZone);
  } else {
    // Otherwise, preserve the offset of the original date.
    ms = epochFromDate(dateTime) - dateTime.offset;
  } // Perform time manipulation in milliseconds rather than on the original time fields to account for DST.
  // For example, adding one hour during a DST transition may result in the hour field staying the same or
  // skipping an hour. This results in the offset field changing value instead of the specified field.


  ms += duration.milliseconds || 0;
  ms += (duration.seconds || 0) * 1000;
  ms += (duration.minutes || 0) * 60 * 1000;
  ms += (duration.hours || 0) * 60 * 60 * 1000;
  var res = fromAbsolute(ms, dateTime.timeZone);
  return toCalendar(res, dateTime.calendar);
}

function $bacf9a69bf9753afe9f94cd9dd8aa2ad$export$subtractZoned(dateTime, duration) {
  return $bacf9a69bf9753afe9f94cd9dd8aa2ad$export$addZoned(dateTime, $bacf9a69bf9753afe9f94cd9dd8aa2ad$export$invertDuration(duration));
}

function $bacf9a69bf9753afe9f94cd9dd8aa2ad$export$cycleZoned(dateTime, field, amount, options) {
  // For date fields, we want the time to remain consistent and the UTC offset to potentially change to account for DST changes.
  // For time fields, we want the time to change by the amount given. This may result in the hour field staying the same, but the UTC
  // offset changing in the case of a backward DST transition, or skipping an hour in the case of a forward DST transition.
  switch (field) {
    case 'hour':
      {
        var min = 0;
        var max = 23;

        if ((options == null ? void 0 : options.hourCycle) === 12) {
          var isPM = dateTime.hour >= 12;
          min = isPM ? 12 : 0;
          max = isPM ? 23 : 11;
        } // The minimum and maximum hour may be affected by daylight saving time.
        // For example, it might jump forward at midnight, and skip 1am.
        // Or it might end at midnight and repeat the 11pm hour. To handle this, we get
        // the possible absolute times for the min and max, and find the maximum range
        // that is within the current day.


        var plainDateTime = toCalendarDateTime(dateTime);

        var _minDate = toCalendar($bacf9a69bf9753afe9f94cd9dd8aa2ad$export$setTime(plainDateTime, {
          hour: min
        }), new GregorianCalendar());

        var minAbsolute = [toAbsolute(_minDate, dateTime.timeZone, 'earlier'), toAbsolute(_minDate, dateTime.timeZone, 'later')].filter(function (ms) {
          return fromAbsolute(ms, dateTime.timeZone).day === _minDate.day;
        })[0];

        var _maxDate = toCalendar($bacf9a69bf9753afe9f94cd9dd8aa2ad$export$setTime(plainDateTime, {
          hour: max
        }), new GregorianCalendar());

        var maxAbsolute = [toAbsolute(_maxDate, dateTime.timeZone, 'earlier'), toAbsolute(_maxDate, dateTime.timeZone, 'later')].filter(function (ms) {
          return fromAbsolute(ms, dateTime.timeZone).day === _maxDate.day;
        }).pop(); // Since hours may repeat, we need to operate on the absolute time in milliseconds.
        // This is done in hours from the Unix epoch so that cycleValue works correctly,
        // and then converted back to milliseconds.

        var ms = epochFromDate(dateTime) - dateTime.offset;
        var hours = Math.floor(ms / $bacf9a69bf9753afe9f94cd9dd8aa2ad$var$ONE_HOUR);
        var remainder = ms % $bacf9a69bf9753afe9f94cd9dd8aa2ad$var$ONE_HOUR;
        ms = $bacf9a69bf9753afe9f94cd9dd8aa2ad$var$cycleValue(hours, amount, Math.floor(minAbsolute / $bacf9a69bf9753afe9f94cd9dd8aa2ad$var$ONE_HOUR), Math.floor(maxAbsolute / $bacf9a69bf9753afe9f94cd9dd8aa2ad$var$ONE_HOUR), options == null ? void 0 : options.round) * $bacf9a69bf9753afe9f94cd9dd8aa2ad$var$ONE_HOUR + remainder; // Now compute the new timezone offset, and convert the absolute time back to local time.

        return toCalendar(fromAbsolute(ms, dateTime.timeZone), dateTime.calendar);
      }

    case 'minute':
    case 'second':
    case 'millisecond':
      // @ts-ignore
      return $bacf9a69bf9753afe9f94cd9dd8aa2ad$export$cycleTime(dateTime, field, amount, options);

    case 'era':
    case 'year':
    case 'month':
    case 'day':
      {
        var res = $bacf9a69bf9753afe9f94cd9dd8aa2ad$export$cycleDate(toCalendarDateTime(dateTime), field, amount, options);

        var _ms = toAbsolute(res, dateTime.timeZone);

        return toCalendar(fromAbsolute(_ms, dateTime.timeZone), dateTime.calendar);
      }

    default:
      throw new Error('Unsupported field ' + field);
  }
}

function $bacf9a69bf9753afe9f94cd9dd8aa2ad$export$setZoned(dateTime, fields, disambiguation) {
  // Set the date/time fields, and recompute the UTC offset to account for DST changes.
  // We also need to validate by converting back to a local time in case hours are skipped during forward DST transitions.
  var plainDateTime = toCalendarDateTime(dateTime);
  var res = $bacf9a69bf9753afe9f94cd9dd8aa2ad$export$setTime($bacf9a69bf9753afe9f94cd9dd8aa2ad$export$set(plainDateTime, fields), fields); // If the resulting plain date time values are equal, return the original time.
  // We don't want to change the offset when setting the time to the same value.

  if (res.compare(plainDateTime) === 0) {
    return dateTime;
  }

  var ms = toAbsolute(res, dateTime.timeZone, disambiguation);
  return toCalendar(fromAbsolute(ms, dateTime.timeZone), dateTime.calendar);
}

var $c02c03a25b07d7f5b716aff41996250f$var$TIME_RE = /^(\d{2})(?::(\d{2}))?(?::(\d{2}))?(\.\d+)?$/;
var $c02c03a25b07d7f5b716aff41996250f$var$DATE_RE = /^(\d{4})-(\d{2})-(\d{2})$/;
var $c02c03a25b07d7f5b716aff41996250f$var$DATE_TIME_RE = /^(\d{4})-(\d{2})-(\d{2})(?:T(\d{2}))?(?::(\d{2}))?(?::(\d{2}))?(\.\d+)?$/;
var $c02c03a25b07d7f5b716aff41996250f$var$ZONED_DATE_TIME_RE = /^(\d{4})-(\d{2})-(\d{2})(?:T(\d{2}))?(?::(\d{2}))?(?::(\d{2}))?(\.\d+)?(?:([+-]\d{2})(?::(\d{2}))?)?\[(.*?)\]$/;
var $c02c03a25b07d7f5b716aff41996250f$var$ABSOLUTE_RE = /^(\d{4})-(\d{2})-(\d{2})(?:T(\d{2}))?(?::(\d{2}))?(?::(\d{2}))?(\.\d+)?(?:(?:([+-]\d{2})(?::(\d{2}))?)|Z)$/;
export function parseTime(value) {
  var m = value.match($c02c03a25b07d7f5b716aff41996250f$var$TIME_RE);

  if (!m) {
    throw new Error('Invalid ISO 8601 time string: ' + value);
  }

  return new Time($c02c03a25b07d7f5b716aff41996250f$var$parseNumber(m[1], 0, 23), m[2] ? $c02c03a25b07d7f5b716aff41996250f$var$parseNumber(m[2], 0, 59) : 0, m[3] ? $c02c03a25b07d7f5b716aff41996250f$var$parseNumber(m[3], 0, 59) : 0, m[4] ? $c02c03a25b07d7f5b716aff41996250f$var$parseNumber(m[4], 0, Infinity) * 1000 : 0);
}
export function parseDate(value) {
  var m = value.match($c02c03a25b07d7f5b716aff41996250f$var$DATE_RE);

  if (!m) {
    throw new Error('Invalid ISO 8601 date string: ' + value);
  }

  var date = new CalendarDate($c02c03a25b07d7f5b716aff41996250f$var$parseNumber(m[1], 0, 9999), $c02c03a25b07d7f5b716aff41996250f$var$parseNumber(m[2], 1, 12), 1);
  date.day = $c02c03a25b07d7f5b716aff41996250f$var$parseNumber(m[3], 0, date.calendar.getDaysInMonth(date));
  return date;
}
export function parseDateTime(value) {
  var m = value.match($c02c03a25b07d7f5b716aff41996250f$var$DATE_TIME_RE);

  if (!m) {
    throw new Error('Invalid ISO 8601 date time string: ' + value);
  }

  var date = new CalendarDateTime($c02c03a25b07d7f5b716aff41996250f$var$parseNumber(m[1], 1, 9999), $c02c03a25b07d7f5b716aff41996250f$var$parseNumber(m[2], 1, 12), 1, m[4] ? $c02c03a25b07d7f5b716aff41996250f$var$parseNumber(m[4], 0, 23) : 0, m[5] ? $c02c03a25b07d7f5b716aff41996250f$var$parseNumber(m[5], 0, 59) : 0, m[6] ? $c02c03a25b07d7f5b716aff41996250f$var$parseNumber(m[6], 0, 59) : 0, m[7] ? $c02c03a25b07d7f5b716aff41996250f$var$parseNumber(m[7], 0, Infinity) * 1000 : 0);
  date.day = $c02c03a25b07d7f5b716aff41996250f$var$parseNumber(m[3], 0, date.calendar.getDaysInMonth(date));
  return date;
}
export function parseZonedDateTime(value, disambiguation) {
  var m = value.match($c02c03a25b07d7f5b716aff41996250f$var$ZONED_DATE_TIME_RE);

  if (!m) {
    throw new Error('Invalid ISO 8601 date time string: ' + value);
  }

  var date = new ZonedDateTime($c02c03a25b07d7f5b716aff41996250f$var$parseNumber(m[1], 1, 9999), $c02c03a25b07d7f5b716aff41996250f$var$parseNumber(m[2], 1, 12), 1, m[10], 0, m[4] ? $c02c03a25b07d7f5b716aff41996250f$var$parseNumber(m[4], 0, 23) : 0, m[5] ? $c02c03a25b07d7f5b716aff41996250f$var$parseNumber(m[5], 0, 59) : 0, m[6] ? $c02c03a25b07d7f5b716aff41996250f$var$parseNumber(m[6], 0, 59) : 0, m[7] ? $c02c03a25b07d7f5b716aff41996250f$var$parseNumber(m[7], 0, Infinity) * 1000 : 0);
  date.day = $c02c03a25b07d7f5b716aff41996250f$var$parseNumber(m[3], 0, date.calendar.getDaysInMonth(date));
  var plainDateTime = toCalendarDateTime(date);
  var ms;

  if (m[8]) {
    var _m$;

    date.offset = $c02c03a25b07d7f5b716aff41996250f$var$parseNumber(m[8], -23, 23) * 60 * 60 * 1000 + $c02c03a25b07d7f5b716aff41996250f$var$parseNumber((_m$ = m[9]) != null ? _m$ : '0', 0, 59) * 60 * 1000;
    ms = epochFromDate(date) - date.offset; // Validate offset against parsed date.

    var absolutes = possibleAbsolutes(plainDateTime, date.timeZone);

    if (!absolutes.includes(ms)) {
      throw new Error("Offset " + $c02c03a25b07d7f5b716aff41996250f$var$offsetToString(date.offset) + " is invalid for " + dateTimeToString(date) + " in " + date.timeZone);
    }
  } else {
    // Convert to absolute and back to fix invalid times due to DST.
    ms = toAbsolute(toCalendarDateTime(plainDateTime), date.timeZone, disambiguation);
  }

  return fromAbsolute(ms, date.timeZone);
}
export function parseAbsolute(value, timeZone) {
  var m = value.match($c02c03a25b07d7f5b716aff41996250f$var$ABSOLUTE_RE);

  if (!m) {
    throw new Error('Invalid ISO 8601 date time string: ' + value);
  }

  var date = new ZonedDateTime($c02c03a25b07d7f5b716aff41996250f$var$parseNumber(m[1], 1, 9999), $c02c03a25b07d7f5b716aff41996250f$var$parseNumber(m[2], 1, 12), 1, timeZone, 0, m[4] ? $c02c03a25b07d7f5b716aff41996250f$var$parseNumber(m[4], 0, 23) : 0, m[5] ? $c02c03a25b07d7f5b716aff41996250f$var$parseNumber(m[5], 0, 59) : 0, m[6] ? $c02c03a25b07d7f5b716aff41996250f$var$parseNumber(m[6], 0, 59) : 0, m[7] ? $c02c03a25b07d7f5b716aff41996250f$var$parseNumber(m[7], 0, Infinity) * 1000 : 0);
  date.day = $c02c03a25b07d7f5b716aff41996250f$var$parseNumber(m[3], 0, date.calendar.getDaysInMonth(date));

  if (m[8]) {
    var _m$2;

    date.offset = $c02c03a25b07d7f5b716aff41996250f$var$parseNumber(m[8], -23, 23) * 60 * 60 * 1000 + $c02c03a25b07d7f5b716aff41996250f$var$parseNumber((_m$2 = m[9]) != null ? _m$2 : '0', 0, 59) * 60 * 1000;
  }

  return toTimeZone(date, timeZone);
}
export function parseAbsoluteToLocal(value) {
  return parseAbsolute(value, getLocalTimeZone());
}

function $c02c03a25b07d7f5b716aff41996250f$var$parseNumber(value, min, max) {
  var val = Number(value);

  if (val < min || val > max) {
    throw new RangeError("Value out of range: " + min + " <= " + val + " <= " + max);
  }

  return val;
}

export function timeToString(time) {
  return String(time.hour).padStart(2, '0') + ":" + String(time.minute).padStart(2, '0') + ":" + String(time.second).padStart(2, '0') + (time.millisecond ? String(time.millisecond / 1000).slice(1) : '');
}
export function dateToString(date) {
  var gregorianDate = toCalendar(date, new GregorianCalendar());
  return String(gregorianDate.year).padStart(4, '0') + "-" + String(gregorianDate.month).padStart(2, '0') + "-" + String(gregorianDate.day).padStart(2, '0');
}
export function dateTimeToString(date) {
  // @ts-ignore
  return dateToString(date) + "T" + timeToString(date);
}

function $c02c03a25b07d7f5b716aff41996250f$var$offsetToString(offset) {
  var sign = Math.sign(offset) < 0 ? '-' : '+';
  offset = Math.abs(offset);
  var offsetHours = Math.floor(offset / (60 * 60 * 1000));
  var offsetMinutes = offset % (60 * 60 * 1000) / (60 * 1000);
  return "" + sign + String(offsetHours).padStart(2, '0') + ":" + String(offsetMinutes).padStart(2, '0');
}

export function zonedDateTimeToString(date) {
  return "" + dateTimeToString(date) + $c02c03a25b07d7f5b716aff41996250f$var$offsetToString(date.offset) + "[" + date.timeZone + "]";
}

function $a390250d74cf918aad5b3b22927402a$var$shiftArgs(args) {
  var calendar = typeof args[0] === 'object' ? args.shift() : new GregorianCalendar();
  var era;

  if (typeof args[0] === 'string') {
    era = args.shift();
  } else {
    var eras = calendar.getEras();
    era = eras[eras.length - 1];
  }

  var year = args.shift();
  var month = args.shift();
  var day = args.shift();
  return [calendar, era, year, month, day];
}

var $a390250d74cf918aad5b3b22927402a$var$_type = _babelRuntimeHelpersEsmClassPrivateFieldLooseKey("type");

export var CalendarDate = /*#__PURE__*/function () {
  // This prevents TypeScript from allowing other types with the same fields to match.
  // i.e. a ZonedDateTime should not be be passable to a parameter that expects CalendarDate.
  // If that behavior is desired, use the AnyCalendarDate interface instead.
  function CalendarDate() {
    _classCallCheck(this, CalendarDate);

    Object.defineProperty(this, $a390250d74cf918aad5b3b22927402a$var$_type, {
      writable: true,
      value: void 0
    });
    this.calendar = void 0;
    this.era = void 0;
    this.year = void 0;
    this.month = void 0;
    this.day = void 0;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var _$a390250d74cf918aad = $a390250d74cf918aad5b3b22927402a$var$shiftArgs(args),
        _$a390250d74cf918aad2 = _slicedToArray(_$a390250d74cf918aad, 5),
        calendar = _$a390250d74cf918aad2[0],
        era = _$a390250d74cf918aad2[1],
        year = _$a390250d74cf918aad2[2],
        month = _$a390250d74cf918aad2[3],
        day = _$a390250d74cf918aad2[4];

    this.calendar = calendar;
    this.era = era;
    this.year = year;
    this.month = month;
    this.day = day;
    $bacf9a69bf9753afe9f94cd9dd8aa2ad$export$constrain(this);
  }

  _createClass(CalendarDate, [{
    key: "copy",
    value: function copy() {
      if (this.era) {
        return new CalendarDate(this.calendar, this.era, this.year, this.month, this.day);
      } else {
        return new CalendarDate(this.calendar, this.year, this.month, this.day);
      }
    }
  }, {
    key: "add",
    value: function add(duration) {
      return $bacf9a69bf9753afe9f94cd9dd8aa2ad$export$add(this, duration);
    }
  }, {
    key: "subtract",
    value: function subtract(duration) {
      return $bacf9a69bf9753afe9f94cd9dd8aa2ad$export$subtract(this, duration);
    }
  }, {
    key: "set",
    value: function set(fields) {
      return $bacf9a69bf9753afe9f94cd9dd8aa2ad$export$set(this, fields);
    }
  }, {
    key: "cycle",
    value: function cycle(field, amount, options) {
      return $bacf9a69bf9753afe9f94cd9dd8aa2ad$export$cycleDate(this, field, amount, options);
    }
  }, {
    key: "toDate",
    value: function toDate(timeZone) {
      return _toDate(this, timeZone);
    }
  }, {
    key: "toString",
    value: function toString() {
      return dateToString(this);
    }
  }, {
    key: "compare",
    value: function compare(b) {
      return compareDate(this, b);
    }
  }]);

  return CalendarDate;
}();

var $a390250d74cf918aad5b3b22927402a$var$_type2 = _babelRuntimeHelpersEsmClassPrivateFieldLooseKey("type");

export var Time = /*#__PURE__*/function () {
  // This prevents TypeScript from allowing other types with the same fields to match.
  function Time() {
    var hour = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    var minute = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    var second = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
    var millisecond = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;

    _classCallCheck(this, Time);

    this.hour = hour;
    this.minute = minute;
    this.second = second;
    this.millisecond = millisecond;
    Object.defineProperty(this, $a390250d74cf918aad5b3b22927402a$var$_type2, {
      writable: true,
      value: void 0
    });
    $bacf9a69bf9753afe9f94cd9dd8aa2ad$export$constrainTime(this);
  }

  _createClass(Time, [{
    key: "copy",
    value: function copy() {
      return new Time(this.hour, this.minute, this.second, this.millisecond);
    }
  }, {
    key: "add",
    value: function add(duration) {
      return $bacf9a69bf9753afe9f94cd9dd8aa2ad$export$addTime(this, duration);
    }
  }, {
    key: "subtract",
    value: function subtract(duration) {
      return $bacf9a69bf9753afe9f94cd9dd8aa2ad$export$subtractTime(this, duration);
    }
  }, {
    key: "set",
    value: function set(fields) {
      return $bacf9a69bf9753afe9f94cd9dd8aa2ad$export$setTime(this, fields);
    }
  }, {
    key: "cycle",
    value: function cycle(field, amount, options) {
      return $bacf9a69bf9753afe9f94cd9dd8aa2ad$export$cycleTime(this, field, amount, options);
    }
  }, {
    key: "toString",
    value: function toString() {
      return timeToString(this);
    }
  }, {
    key: "compare",
    value: function compare(b) {
      return compareTime(this, b);
    }
  }]);

  return Time;
}();

var $a390250d74cf918aad5b3b22927402a$var$_type3 = _babelRuntimeHelpersEsmClassPrivateFieldLooseKey("type");

export var CalendarDateTime = /*#__PURE__*/function () {
  // This prevents TypeScript from allowing other types with the same fields to match.
  function CalendarDateTime() {
    _classCallCheck(this, CalendarDateTime);

    Object.defineProperty(this, $a390250d74cf918aad5b3b22927402a$var$_type3, {
      writable: true,
      value: void 0
    });
    this.calendar = void 0;
    this.era = void 0;
    this.year = void 0;
    this.month = void 0;
    this.day = void 0;
    this.hour = void 0;
    this.minute = void 0;
    this.second = void 0;
    this.millisecond = void 0;

    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    var _$a390250d74cf918aad3 = $a390250d74cf918aad5b3b22927402a$var$shiftArgs(args),
        _$a390250d74cf918aad4 = _slicedToArray(_$a390250d74cf918aad3, 5),
        calendar = _$a390250d74cf918aad4[0],
        era = _$a390250d74cf918aad4[1],
        year = _$a390250d74cf918aad4[2],
        month = _$a390250d74cf918aad4[3],
        day = _$a390250d74cf918aad4[4];

    this.calendar = calendar;
    this.era = era;
    this.year = year;
    this.month = month;
    this.day = day;
    this.hour = args.shift() || 0;
    this.minute = args.shift() || 0;
    this.second = args.shift() || 0;
    this.millisecond = args.shift() || 0;
    $bacf9a69bf9753afe9f94cd9dd8aa2ad$export$constrain(this);
  }

  _createClass(CalendarDateTime, [{
    key: "copy",
    value: function copy() {
      if (this.era) {
        return new CalendarDateTime(this.calendar, this.era, this.year, this.month, this.day, this.hour, this.minute, this.second, this.millisecond);
      } else {
        return new CalendarDateTime(this.calendar, this.year, this.month, this.day, this.hour, this.minute, this.second, this.millisecond);
      }
    }
  }, {
    key: "add",
    value: function add(duration) {
      return $bacf9a69bf9753afe9f94cd9dd8aa2ad$export$add(this, duration);
    }
  }, {
    key: "subtract",
    value: function subtract(duration) {
      return $bacf9a69bf9753afe9f94cd9dd8aa2ad$export$subtract(this, duration);
    }
  }, {
    key: "set",
    value: function set(fields) {
      return $bacf9a69bf9753afe9f94cd9dd8aa2ad$export$set($bacf9a69bf9753afe9f94cd9dd8aa2ad$export$setTime(this, fields), fields);
    }
  }, {
    key: "cycle",
    value: function cycle(field, amount, options) {
      switch (field) {
        case 'era':
        case 'year':
        case 'month':
        case 'day':
          return $bacf9a69bf9753afe9f94cd9dd8aa2ad$export$cycleDate(this, field, amount, options);

        default:
          return $bacf9a69bf9753afe9f94cd9dd8aa2ad$export$cycleTime(this, field, amount, options);
      }
    }
  }, {
    key: "toDate",
    value: function toDate(timeZone) {
      return _toDate(this, timeZone);
    }
  }, {
    key: "toString",
    value: function toString() {
      return dateTimeToString(this);
    }
  }, {
    key: "compare",
    value: function compare(b) {
      var res = compareDate(this, b);

      if (res === 0) {
        return compareTime(this, toCalendarDateTime(b));
      }

      return res;
    }
  }]);

  return CalendarDateTime;
}();

var $a390250d74cf918aad5b3b22927402a$var$_type4 = _babelRuntimeHelpersEsmClassPrivateFieldLooseKey("type");

export var ZonedDateTime = /*#__PURE__*/function () {
  // This prevents TypeScript from allowing other types with the same fields to match.
  function ZonedDateTime() {
    _classCallCheck(this, ZonedDateTime);

    Object.defineProperty(this, $a390250d74cf918aad5b3b22927402a$var$_type4, {
      writable: true,
      value: void 0
    });
    this.calendar = void 0;
    this.era = void 0;
    this.year = void 0;
    this.month = void 0;
    this.day = void 0;
    this.hour = void 0;
    this.minute = void 0;
    this.second = void 0;
    this.millisecond = void 0;
    this.timeZone = void 0;
    this.offset = void 0;

    for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
      args[_key3] = arguments[_key3];
    }

    var _$a390250d74cf918aad5 = $a390250d74cf918aad5b3b22927402a$var$shiftArgs(args),
        _$a390250d74cf918aad6 = _slicedToArray(_$a390250d74cf918aad5, 5),
        calendar = _$a390250d74cf918aad6[0],
        era = _$a390250d74cf918aad6[1],
        year = _$a390250d74cf918aad6[2],
        month = _$a390250d74cf918aad6[3],
        day = _$a390250d74cf918aad6[4];

    var timeZone = args.shift();
    var offset = args.shift();
    this.calendar = calendar;
    this.era = era;
    this.year = year;
    this.month = month;
    this.day = day;
    this.timeZone = timeZone;
    this.offset = offset;
    this.hour = args.shift() || 0;
    this.minute = args.shift() || 0;
    this.second = args.shift() || 0;
    this.millisecond = args.shift() || 0;
    $bacf9a69bf9753afe9f94cd9dd8aa2ad$export$constrain(this);
  }

  _createClass(ZonedDateTime, [{
    key: "copy",
    value: function copy() {
      if (this.era) {
        return new ZonedDateTime(this.calendar, this.era, this.year, this.month, this.day, this.timeZone, this.offset, this.hour, this.minute, this.second, this.millisecond);
      } else {
        return new ZonedDateTime(this.calendar, this.year, this.month, this.day, this.timeZone, this.offset, this.hour, this.minute, this.second, this.millisecond);
      }
    }
  }, {
    key: "add",
    value: function add(duration) {
      return $bacf9a69bf9753afe9f94cd9dd8aa2ad$export$addZoned(this, duration);
    }
  }, {
    key: "subtract",
    value: function subtract(duration) {
      return $bacf9a69bf9753afe9f94cd9dd8aa2ad$export$subtractZoned(this, duration);
    }
  }, {
    key: "set",
    value: function set(fields, disambiguation) {
      return $bacf9a69bf9753afe9f94cd9dd8aa2ad$export$setZoned(this, fields, disambiguation);
    }
  }, {
    key: "cycle",
    value: function cycle(field, amount, options) {
      return $bacf9a69bf9753afe9f94cd9dd8aa2ad$export$cycleZoned(this, field, amount, options);
    }
  }, {
    key: "toDate",
    value: function toDate() {
      return zonedToDate(this);
    }
  }, {
    key: "toString",
    value: function toString() {
      return zonedDateTimeToString(this);
    }
  }, {
    key: "toAbsoluteString",
    value: function toAbsoluteString() {
      return this.toDate().toISOString();
    }
  }, {
    key: "compare",
    value: function compare(b) {
      // TODO: Is this a bad idea??
      return this.toDate().getTime() - toZoned(b, this.timeZone).toDate().getTime();
    }
  }]);

  return ZonedDateTime;
}();
var $f8ec25d0a093dcb9c8555fe0814edf2c$var$ERA_START_DATES = [[1868, 9, 8], [1912, 7, 30], [1926, 12, 25], [1989, 1, 8], [2019, 5, 1]];
var $f8ec25d0a093dcb9c8555fe0814edf2c$var$ERA_END_DATES = [[1912, 7, 29], [1926, 12, 24], [1989, 1, 7], [2019, 4, 30]];
var $f8ec25d0a093dcb9c8555fe0814edf2c$var$ERA_ADDENDS = [1867, 1911, 1925, 1988, 2018];
var $f8ec25d0a093dcb9c8555fe0814edf2c$var$ERA_NAMES = ['meiji', 'taisho', 'showa', 'heisei', 'reiwa'];

function $f8ec25d0a093dcb9c8555fe0814edf2c$var$findEraFromGregorianDate(date) {
  var idx = $f8ec25d0a093dcb9c8555fe0814edf2c$var$ERA_START_DATES.findIndex(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 3),
        year = _ref2[0],
        month = _ref2[1],
        day = _ref2[2];

    if (date.year < year) {
      return true;
    }

    if (date.year === year && date.month < month) {
      return true;
    }

    if (date.year === year && date.month === month && date.day < day) {
      return true;
    }

    return false;
  });

  if (idx === -1) {
    return $f8ec25d0a093dcb9c8555fe0814edf2c$var$ERA_START_DATES.length - 1;
  }

  if (idx === 0) {
    return 0;
  }

  return idx - 1;
}

function $f8ec25d0a093dcb9c8555fe0814edf2c$var$toGregorian(date) {
  var eraAddend = $f8ec25d0a093dcb9c8555fe0814edf2c$var$ERA_ADDENDS[$f8ec25d0a093dcb9c8555fe0814edf2c$var$ERA_NAMES.indexOf(date.era)];

  if (!eraAddend) {
    throw new Error('Unknown era: ' + date.era);
  }

  return new CalendarDate(date.year + eraAddend, date.month, date.day);
}

export var JapaneseCalendar = /*#__PURE__*/function (_GregorianCalendar) {
  _inherits(JapaneseCalendar, _GregorianCalendar);

  var _super = _createSuper(JapaneseCalendar);

  function JapaneseCalendar() {
    var _this;

    _classCallCheck(this, JapaneseCalendar);

    _this = _super.apply(this, arguments);
    _this.identifier = 'japanese';
    return _this;
  }

  _createClass(JapaneseCalendar, [{
    key: "fromJulianDay",
    value: function fromJulianDay(jd) {
      var date = _get(_getPrototypeOf(JapaneseCalendar.prototype), "fromJulianDay", this).call(this, jd);

      var era = $f8ec25d0a093dcb9c8555fe0814edf2c$var$findEraFromGregorianDate(date);
      date.era = $f8ec25d0a093dcb9c8555fe0814edf2c$var$ERA_NAMES[era];
      date.year -= $f8ec25d0a093dcb9c8555fe0814edf2c$var$ERA_ADDENDS[era];
      return date;
    }
  }, {
    key: "toJulianDay",
    value: function toJulianDay(date) {
      return _get(_getPrototypeOf(JapaneseCalendar.prototype), "toJulianDay", this).call(this, $f8ec25d0a093dcb9c8555fe0814edf2c$var$toGregorian(date));
    }
  }, {
    key: "balanceDate",
    value: function balanceDate(date) {
      var gregorianDate = $f8ec25d0a093dcb9c8555fe0814edf2c$var$toGregorian(date);
      var era = $f8ec25d0a093dcb9c8555fe0814edf2c$var$findEraFromGregorianDate(gregorianDate);

      if ($f8ec25d0a093dcb9c8555fe0814edf2c$var$ERA_NAMES[era] !== date.era) {
        date.era = $f8ec25d0a093dcb9c8555fe0814edf2c$var$ERA_NAMES[era];
        date.year = gregorianDate.year - $f8ec25d0a093dcb9c8555fe0814edf2c$var$ERA_ADDENDS[era];
      }
    }
  }, {
    key: "constrainDate",
    value: function constrainDate(date) {
      var idx = $f8ec25d0a093dcb9c8555fe0814edf2c$var$ERA_NAMES.indexOf(date.era);
      var end = $f8ec25d0a093dcb9c8555fe0814edf2c$var$ERA_END_DATES[idx];

      if (end != null) {
        var _end = _slicedToArray(end, 3),
            endYear = _end[0],
            endMonth = _end[1],
            endDay = _end[2]; // Constrain the year to the maximum possible value in the era.
        // Then constrain the month and day fields within that.


        var maxYear = endYear - $f8ec25d0a093dcb9c8555fe0814edf2c$var$ERA_ADDENDS[idx];
        date.year = Math.min(maxYear, date.year);

        if (date.year === maxYear) {
          date.month = Math.min(endMonth, date.month);

          if (date.month === endMonth) {
            date.day = Math.min(endDay, date.day);
          }
        }

        if (date.year === 1) {
          var _$f8ec25d0a093dcb9c = _slicedToArray($f8ec25d0a093dcb9c8555fe0814edf2c$var$ERA_START_DATES[idx], 3),
              startMonth = _$f8ec25d0a093dcb9c[1],
              startDay = _$f8ec25d0a093dcb9c[2];

          date.month = Math.max(startMonth, date.month);

          if (date.month === startMonth) {
            date.day = Math.max(startDay, date.day);
          }
        }
      }
    }
  }, {
    key: "getEras",
    value: function getEras() {
      return $f8ec25d0a093dcb9c8555fe0814edf2c$var$ERA_NAMES;
    }
  }, {
    key: "getYearsInEra",
    value: function getYearsInEra(date) {
      // Get the number of years in the era, taking into account the date's month and day fields.
      var era = $f8ec25d0a093dcb9c8555fe0814edf2c$var$ERA_NAMES.indexOf(date.era);
      var next = $f8ec25d0a093dcb9c8555fe0814edf2c$var$ERA_START_DATES[era + 1];

      if (next == null) {
        return 9999;
      }

      var cur = $f8ec25d0a093dcb9c8555fe0814edf2c$var$ERA_START_DATES[era];
      var years = next[0] - cur[0];

      if (date.month < next[1] || date.month === next[1] && date.day < next[2]) {
        years++;
      }

      return years;
    }
  }, {
    key: "getMinimumMonthInYear",
    value: function getMinimumMonthInYear(date) {
      var start = $f8ec25d0a093dcb9c8555fe0814edf2c$var$getMinimums(date);
      return start ? start[1] : 1;
    }
  }, {
    key: "getMinimumDayInMonth",
    value: function getMinimumDayInMonth(date) {
      var start = $f8ec25d0a093dcb9c8555fe0814edf2c$var$getMinimums(date);
      return start && date.month === start[1] ? start[2] : 1;
    }
  }]);

  return JapaneseCalendar;
}(GregorianCalendar);

function $f8ec25d0a093dcb9c8555fe0814edf2c$var$getMinimums(date) {
  if (date.year === 1) {
    var idx = $f8ec25d0a093dcb9c8555fe0814edf2c$var$ERA_NAMES.indexOf(date.era);
    return $f8ec25d0a093dcb9c8555fe0814edf2c$var$ERA_START_DATES[idx];
  }
}

var $c3ac3d7d08bcbe41bf4ee53f1885ac37$var$BUDDHIST_ERA_START = -543;
export var BuddhistCalendar = /*#__PURE__*/function (_GregorianCalendar2) {
  _inherits(BuddhistCalendar, _GregorianCalendar2);

  var _super2 = _createSuper(BuddhistCalendar);

  function BuddhistCalendar() {
    var _this2;

    _classCallCheck(this, BuddhistCalendar);

    _this2 = _super2.apply(this, arguments);
    _this2.identifier = 'buddhist';
    return _this2;
  }

  _createClass(BuddhistCalendar, [{
    key: "fromJulianDay",
    value: function fromJulianDay(jd) {
      var date = _get(_getPrototypeOf(BuddhistCalendar.prototype), "fromJulianDay", this).call(this, jd);

      date.year -= $c3ac3d7d08bcbe41bf4ee53f1885ac37$var$BUDDHIST_ERA_START;
      return date;
    }
  }, {
    key: "toJulianDay",
    value: function toJulianDay(date) {
      return _get(_getPrototypeOf(BuddhistCalendar.prototype), "toJulianDay", this).call(this, new CalendarDate(date.year + $c3ac3d7d08bcbe41bf4ee53f1885ac37$var$BUDDHIST_ERA_START, date.month, date.day));
    }
  }, {
    key: "getEras",
    value: function getEras() {
      return ['BE'];
    }
  }]);

  return BuddhistCalendar;
}(GregorianCalendar);
var $a1f87b3cef47dd44f95e400d2f520895$var$TAIWAN_ERA_START = 1911;

function $a1f87b3cef47dd44f95e400d2f520895$var$gregorianYear(date) {
  return date.era === 'minguo' ? date.year + $a1f87b3cef47dd44f95e400d2f520895$var$TAIWAN_ERA_START : 1 - date.year + $a1f87b3cef47dd44f95e400d2f520895$var$TAIWAN_ERA_START;
}

function $a1f87b3cef47dd44f95e400d2f520895$var$gregorianToTaiwan(year, date) {
  var y = year - $a1f87b3cef47dd44f95e400d2f520895$var$TAIWAN_ERA_START;

  if (y > 0) {
    date.era = 'minguo';
    date.year = y;
  } else {
    date.era = 'before_minguo';
    date.year = 1 - y;
  }
}

export var TaiwanCalendar = /*#__PURE__*/function (_GregorianCalendar3) {
  _inherits(TaiwanCalendar, _GregorianCalendar3);

  var _super3 = _createSuper(TaiwanCalendar);

  function TaiwanCalendar() {
    var _this3;

    _classCallCheck(this, TaiwanCalendar);

    _this3 = _super3.apply(this, arguments);
    _this3.identifier = 'roc';
    return _this3;
  } // Republic of China


  _createClass(TaiwanCalendar, [{
    key: "fromJulianDay",
    value: function fromJulianDay(jd) {
      var date = _get(_getPrototypeOf(TaiwanCalendar.prototype), "fromJulianDay", this).call(this, jd);

      $a1f87b3cef47dd44f95e400d2f520895$var$gregorianToTaiwan(date.year, date);
      return date;
    }
  }, {
    key: "toJulianDay",
    value: function toJulianDay(date) {
      return _get(_getPrototypeOf(TaiwanCalendar.prototype), "toJulianDay", this).call(this, new CalendarDate($a1f87b3cef47dd44f95e400d2f520895$var$gregorianYear(date), date.month, date.day));
    }
  }, {
    key: "getEras",
    value: function getEras() {
      return ['before_minguo', 'minguo'];
    }
  }, {
    key: "balanceDate",
    value: function balanceDate(date) {
      $a1f87b3cef47dd44f95e400d2f520895$var$gregorianToTaiwan($a1f87b3cef47dd44f95e400d2f520895$var$gregorianYear(date), date);
    }
  }, {
    key: "getYearsToAdd",
    value: function getYearsToAdd(date, years) {
      return date.era === 'before_minguo' ? -years : years;
    }
  }]);

  return TaiwanCalendar;
}(GregorianCalendar);
var $aa128395b22a5a8486d031f5e52cc5$var$PERSIAN_EPOCH = 1948321; // 622/03/19 Julian C.E.

function $aa128395b22a5a8486d031f5e52cc5$var$isLeapYear(year) {
  var y0 = year > 0 ? year - 474 : year - 473;
  var y1 = $e69ae7432d03ee6ff5aa642daa3d5d3$export$mod(y0, 2820) + 474;
  return $e69ae7432d03ee6ff5aa642daa3d5d3$export$mod((y1 + 38) * 31, 128) < 31;
}

function $aa128395b22a5a8486d031f5e52cc5$var$persianToJulianDay(year, month, day) {
  var y0 = year > 0 ? year - 474 : year - 473;
  var y1 = $e69ae7432d03ee6ff5aa642daa3d5d3$export$mod(y0, 2820) + 474;
  var offset = month <= 7 ? 31 * (month - 1) : 30 * (month - 1) + 6;
  return $aa128395b22a5a8486d031f5e52cc5$var$PERSIAN_EPOCH - 1 + 1029983 * Math.floor(y0 / 2820) + 365 * (y1 - 1) + Math.floor((31 * y1 - 5) / 128) + offset + day;
}

export var PersianCalendar = /*#__PURE__*/function () {
  function PersianCalendar() {
    _classCallCheck(this, PersianCalendar);

    this.identifier = 'persian';
  }

  _createClass(PersianCalendar, [{
    key: "fromJulianDay",
    value: function fromJulianDay(jd) {
      var d0 = jd - $aa128395b22a5a8486d031f5e52cc5$var$persianToJulianDay(475, 1, 1);
      var n2820 = Math.floor(d0 / 1029983);
      var d1 = $e69ae7432d03ee6ff5aa642daa3d5d3$export$mod(d0, 1029983);
      var y2820 = d1 === 1029982 ? 2820 : Math.floor((128 * d1 + 46878) / 46751);
      var year = 474 + 2820 * n2820 + y2820;

      if (year <= 0) {
        year--;
      }

      var yDay = jd - $aa128395b22a5a8486d031f5e52cc5$var$persianToJulianDay(year, 1, 1) + 1;
      var month = yDay <= 186 ? Math.ceil(yDay / 31) : Math.ceil((yDay - 6) / 31);
      var day = jd - $aa128395b22a5a8486d031f5e52cc5$var$persianToJulianDay(year, month, 1) + 1;
      return new CalendarDate(this, year, month, day);
    }
  }, {
    key: "toJulianDay",
    value: function toJulianDay(date) {
      return $aa128395b22a5a8486d031f5e52cc5$var$persianToJulianDay(date.year, date.month, date.day);
    }
  }, {
    key: "getMonthsInYear",
    value: function getMonthsInYear() {
      return 12;
    }
  }, {
    key: "getDaysInMonth",
    value: function getDaysInMonth(date) {
      if (date.month <= 6) {
        return 31;
      }

      if (date.month <= 11) {
        return 30;
      }

      return $aa128395b22a5a8486d031f5e52cc5$var$isLeapYear(date.year) ? 30 : 29;
    }
  }, {
    key: "getEras",
    value: function getEras() {
      return ['AP'];
    }
  }, {
    key: "getYearsInEra",
    value: function getYearsInEra() {
      return 9999;
    }
  }]);

  return PersianCalendar;
}(); // Starts in 78 AD,

var $a42213da061f74ad7729814d491de388$var$INDIAN_ERA_START = 78; // The Indian year starts 80 days later than the Gregorian year.

var $a42213da061f74ad7729814d491de388$var$INDIAN_YEAR_START = 80;
export var IndianCalendar = /*#__PURE__*/function (_GregorianCalendar4) {
  _inherits(IndianCalendar, _GregorianCalendar4);

  var _super4 = _createSuper(IndianCalendar);

  function IndianCalendar() {
    var _this4;

    _classCallCheck(this, IndianCalendar);

    _this4 = _super4.apply(this, arguments);
    _this4.identifier = 'indian';
    return _this4;
  }

  _createClass(IndianCalendar, [{
    key: "fromJulianDay",
    value: function fromJulianDay(jd) {
      // Gregorian date for Julian day
      var date = _get(_getPrototypeOf(IndianCalendar.prototype), "fromJulianDay", this).call(this, jd); // Year in Saka era


      var indianYear = date.year - $a42213da061f74ad7729814d491de388$var$INDIAN_ERA_START; // Day number in Gregorian year (starting from 0)

      var yDay = jd - $d9ab185420a4ffb38f7504d41a330b3a$export$gregorianToJulianDay(date.year, 1, 1);
      var leapMonth;

      if (yDay < $a42213da061f74ad7729814d491de388$var$INDIAN_YEAR_START) {
        //  Day is at the end of the preceding Saka year
        indianYear--; // Days in leapMonth this year, previous Gregorian year

        leapMonth = $d9ab185420a4ffb38f7504d41a330b3a$export$isLeapYear(date.year - 1) ? 31 : 30;
        yDay += leapMonth + 31 * 5 + 30 * 3 + 10;
      } else {
        // Days in leapMonth this year
        leapMonth = $d9ab185420a4ffb38f7504d41a330b3a$export$isLeapYear(date.year) ? 31 : 30;
        yDay -= $a42213da061f74ad7729814d491de388$var$INDIAN_YEAR_START;
      }

      var indianMonth;
      var indianDay;

      if (yDay < leapMonth) {
        indianMonth = 1;
        indianDay = yDay + 1;
      } else {
        var mDay = yDay - leapMonth;

        if (mDay < 31 * 5) {
          indianMonth = Math.floor(mDay / 31) + 2;
          indianDay = mDay % 31 + 1;
        } else {
          mDay -= 31 * 5;
          indianMonth = Math.floor(mDay / 30) + 7;
          indianDay = mDay % 30 + 1;
        }
      }

      return new CalendarDate(this, indianYear, indianMonth, indianDay);
    }
  }, {
    key: "toJulianDay",
    value: function toJulianDay(date) {
      var year = date.year + $a42213da061f74ad7729814d491de388$var$INDIAN_ERA_START;
      var leapMonth;
      var jd;

      if ($d9ab185420a4ffb38f7504d41a330b3a$export$isLeapYear(year)) {
        leapMonth = 31;
        jd = $d9ab185420a4ffb38f7504d41a330b3a$export$gregorianToJulianDay(year, 3, 21);
      } else {
        leapMonth = 30;
        jd = $d9ab185420a4ffb38f7504d41a330b3a$export$gregorianToJulianDay(year, 3, 22);
      }

      if (date.month === 1) {
        return jd + date.day - 1;
      }

      jd += leapMonth + Math.min(date.month - 2, 5) * 31;

      if (date.month >= 8) {
        jd += (date.month - 7) * 30;
      }

      jd += date.day - 1;
      return jd;
    }
  }, {
    key: "getDaysInMonth",
    value: function getDaysInMonth(date) {
      if (date.month === 1 && $d9ab185420a4ffb38f7504d41a330b3a$export$isLeapYear(date.year + $a42213da061f74ad7729814d491de388$var$INDIAN_ERA_START)) {
        return 31;
      }

      if (date.month >= 2 && date.month <= 6) {
        return 31;
      }

      return 30;
    }
  }, {
    key: "getYearsInEra",
    value: function getYearsInEra() {
      return 9999;
    }
  }, {
    key: "getEras",
    value: function getEras() {
      return ['saka'];
    }
  }]);

  return IndianCalendar;
}(GregorianCalendar);
var $ab59ff19176390aebd417f116829f2f$var$CIVIL_EPOC = 1948440; // CE 622 July 16 Friday (Julian calendar) / CE 622 July 19 (Gregorian calendar)

var $ab59ff19176390aebd417f116829f2f$var$ASTRONOMICAL_EPOC = 1948439; // CE 622 July 15 Thursday (Julian calendar)

var $ab59ff19176390aebd417f116829f2f$var$UMALQURA_YEAR_START = 1300;
var $ab59ff19176390aebd417f116829f2f$var$UMALQURA_YEAR_END = 1600;
var $ab59ff19176390aebd417f116829f2f$var$UMALQURA_START_DAYS = 460322;

function $ab59ff19176390aebd417f116829f2f$var$islamicToJulianDay(epoch, year, month, day) {
  return day + Math.ceil(29.5 * (month - 1)) + (year - 1) * 354 + Math.floor((3 + 11 * year) / 30) + epoch - 1;
}

function $ab59ff19176390aebd417f116829f2f$var$julianDayToIslamic(calendar, epoch, jd) {
  var year = Math.floor((30 * (jd - epoch) + 10646) / 10631);
  var month = Math.min(12, Math.ceil((jd - (29 + $ab59ff19176390aebd417f116829f2f$var$islamicToJulianDay(epoch, year, 1, 1))) / 29.5) + 1);
  var day = jd - $ab59ff19176390aebd417f116829f2f$var$islamicToJulianDay(epoch, year, month, 1) + 1;
  return new CalendarDate(calendar, year, month, day);
}

function $ab59ff19176390aebd417f116829f2f$var$isLeapYear(year) {
  return (14 + 11 * year) % 30 < 11;
}

export var IslamicCivilCalendar = /*#__PURE__*/function () {
  function IslamicCivilCalendar() {
    _classCallCheck(this, IslamicCivilCalendar);

    this.identifier = 'islamic-civil';
  }

  _createClass(IslamicCivilCalendar, [{
    key: "fromJulianDay",
    value: function fromJulianDay(jd) {
      return $ab59ff19176390aebd417f116829f2f$var$julianDayToIslamic(this, $ab59ff19176390aebd417f116829f2f$var$CIVIL_EPOC, jd);
    }
  }, {
    key: "toJulianDay",
    value: function toJulianDay(date) {
      return $ab59ff19176390aebd417f116829f2f$var$islamicToJulianDay($ab59ff19176390aebd417f116829f2f$var$CIVIL_EPOC, date.year, date.month, date.day);
    }
  }, {
    key: "getDaysInMonth",
    value: function getDaysInMonth(date) {
      var length = 29 + date.month % 2;

      if (date.month === 12 && $ab59ff19176390aebd417f116829f2f$var$isLeapYear(date.year)) {
        length++;
      }

      return length;
    }
  }, {
    key: "getMonthsInYear",
    value: function getMonthsInYear() {
      return 12;
    }
  }, {
    key: "getDaysInYear",
    value: function getDaysInYear(date) {
      return $ab59ff19176390aebd417f116829f2f$var$isLeapYear(date.year) ? 355 : 354;
    }
  }, {
    key: "getYearsInEra",
    value: function getYearsInEra() {
      return 9999;
    }
  }, {
    key: "getEras",
    value: function getEras() {
      return ['AH'];
    }
  }]);

  return IslamicCivilCalendar;
}();
export var IslamicTabularCalendar = /*#__PURE__*/function (_IslamicCivilCalendar) {
  _inherits(IslamicTabularCalendar, _IslamicCivilCalendar);

  var _super5 = _createSuper(IslamicTabularCalendar);

  function IslamicTabularCalendar() {
    var _this5;

    _classCallCheck(this, IslamicTabularCalendar);

    _this5 = _super5.apply(this, arguments);
    _this5.identifier = 'islamic-tbla';
    return _this5;
  }

  _createClass(IslamicTabularCalendar, [{
    key: "fromJulianDay",
    value: function fromJulianDay(jd) {
      return $ab59ff19176390aebd417f116829f2f$var$julianDayToIslamic(this, $ab59ff19176390aebd417f116829f2f$var$ASTRONOMICAL_EPOC, jd);
    }
  }, {
    key: "toJulianDay",
    value: function toJulianDay(date) {
      return $ab59ff19176390aebd417f116829f2f$var$islamicToJulianDay($ab59ff19176390aebd417f116829f2f$var$ASTRONOMICAL_EPOC, date.year, date.month, date.day);
    }
  }]);

  return IslamicTabularCalendar;
}(IslamicCivilCalendar); // Generated by scripts/generate-umalqura.js

var $ab59ff19176390aebd417f116829f2f$var$UMALQURA_DATA = 'qgpUDckO1AbqBmwDrQpVBakGkgepC9QF2gpcBS0NlQZKB1QLagutBa4ETwoXBYsGpQbVCtYCWwmdBE0KJg2VDawFtgm6AlsKKwWVCsoG6Qr0AnYJtgJWCcoKpAvSC9kF3AJtCU0FpQpSC6ULtAW2CVcFlwJLBaMGUgdlC2oFqworBZUMSg2lDcoF1gpXCasESwmlClILagt1BXYCtwhbBFUFqQW0BdoJ3QRuAjYJqgpUDbIN1QXaAlsJqwRVCkkLZAtxC7QFtQpVCiUNkg7JDtQG6QprCasEkwpJDaQNsg25CroEWworBZUKKgtVC1wFvQQ9Ah0JlQpKC1oLbQW2AjsJmwRVBqkGVAdqC2wFrQpVBSkLkgupC9QF2gpaBasKlQVJB2QHqgu1BbYCVgpNDiULUgtqC60FrgIvCZcESwalBqwG1gpdBZ0ETQoWDZUNqgW1BdoCWwmtBJUFygbkBuoK9QS2AlYJqgpUC9IL2QXqAm0JrQSVCkoLpQuyBbUJ1gSXCkcFkwZJB1ULagVrCisFiwpGDaMNygXWCtsEawJLCaUKUgtpC3UFdgG3CFsCKwVlBbQF2gntBG0BtgimClINqQ3UBdoKWwmrBFMGKQdiB6kLsgW1ClUFJQuSDckO0gbpCmsFqwRVCikNVA2qDbUJugQ7CpsETQqqCtUK2gJdCV4ELgqaDFUNsga5BroEXQotBZUKUguoC7QLuQXaAloJSgukDdEO6AZqC20FNQWVBkoNqA3UDdoGWwWdAisGFQtKC5ULqgWuCi4JjwwnBZUGqgbWCl0FnQI=';
var $ab59ff19176390aebd417f116829f2f$var$UMALQURA_MONTHLENGTH;
var $ab59ff19176390aebd417f116829f2f$var$UMALQURA_YEAR_START_TABLE;

function $ab59ff19176390aebd417f116829f2f$var$umalquraYearStart(year) {
  return $ab59ff19176390aebd417f116829f2f$var$UMALQURA_START_DAYS + $ab59ff19176390aebd417f116829f2f$var$UMALQURA_YEAR_START_TABLE[year - $ab59ff19176390aebd417f116829f2f$var$UMALQURA_YEAR_START];
}

function $ab59ff19176390aebd417f116829f2f$var$umalquraMonthLength(year, month) {
  var idx = year - $ab59ff19176390aebd417f116829f2f$var$UMALQURA_YEAR_START;
  var mask = 0x01 << 11 - (month - 1);

  if (($ab59ff19176390aebd417f116829f2f$var$UMALQURA_MONTHLENGTH[idx] & mask) === 0) {
    return 29;
  } else {
    return 30;
  }
}

function $ab59ff19176390aebd417f116829f2f$var$umalquraMonthStart(year, month) {
  var day = $ab59ff19176390aebd417f116829f2f$var$umalquraYearStart(year);

  for (var i = 1; i < month; i++) {
    day += $ab59ff19176390aebd417f116829f2f$var$umalquraMonthLength(year, i);
  }

  return day;
}

function $ab59ff19176390aebd417f116829f2f$var$umalquraYearLength(year) {
  return $ab59ff19176390aebd417f116829f2f$var$UMALQURA_YEAR_START_TABLE[year + 1 - $ab59ff19176390aebd417f116829f2f$var$UMALQURA_YEAR_START] - $ab59ff19176390aebd417f116829f2f$var$UMALQURA_YEAR_START_TABLE[year - $ab59ff19176390aebd417f116829f2f$var$UMALQURA_YEAR_START];
}

export var IslamicUmalquraCalendar = /*#__PURE__*/function (_IslamicCivilCalendar2) {
  _inherits(IslamicUmalquraCalendar, _IslamicCivilCalendar2);

  var _super6 = _createSuper(IslamicUmalquraCalendar);

  function IslamicUmalquraCalendar() {
    var _this6;

    _classCallCheck(this, IslamicUmalquraCalendar);

    _this6 = _super6.call(this);
    _this6.identifier = 'islamic-umalqura';

    if (!$ab59ff19176390aebd417f116829f2f$var$UMALQURA_MONTHLENGTH) {
      $ab59ff19176390aebd417f116829f2f$var$UMALQURA_MONTHLENGTH = new Uint16Array(Uint8Array.from(atob($ab59ff19176390aebd417f116829f2f$var$UMALQURA_DATA), function (c) {
        return c.charCodeAt(0);
      }).buffer);
    }

    if (!$ab59ff19176390aebd417f116829f2f$var$UMALQURA_YEAR_START_TABLE) {
      $ab59ff19176390aebd417f116829f2f$var$UMALQURA_YEAR_START_TABLE = new Uint32Array($ab59ff19176390aebd417f116829f2f$var$UMALQURA_YEAR_END - $ab59ff19176390aebd417f116829f2f$var$UMALQURA_YEAR_START + 1);
      var yearStart = 0;

      for (var year = $ab59ff19176390aebd417f116829f2f$var$UMALQURA_YEAR_START; year <= $ab59ff19176390aebd417f116829f2f$var$UMALQURA_YEAR_END; year++) {
        $ab59ff19176390aebd417f116829f2f$var$UMALQURA_YEAR_START_TABLE[year - $ab59ff19176390aebd417f116829f2f$var$UMALQURA_YEAR_START] = yearStart;

        for (var i = 1; i <= 12; i++) {
          yearStart += $ab59ff19176390aebd417f116829f2f$var$umalquraMonthLength(year, i);
        }
      }
    }

    return _this6;
  }

  _createClass(IslamicUmalquraCalendar, [{
    key: "fromJulianDay",
    value: function fromJulianDay(jd) {
      var days = jd - $ab59ff19176390aebd417f116829f2f$var$CIVIL_EPOC;
      var startDays = $ab59ff19176390aebd417f116829f2f$var$umalquraYearStart($ab59ff19176390aebd417f116829f2f$var$UMALQURA_YEAR_START);
      var endDays = $ab59ff19176390aebd417f116829f2f$var$umalquraYearStart($ab59ff19176390aebd417f116829f2f$var$UMALQURA_YEAR_END);

      if (days < startDays || days > endDays) {
        return _get(_getPrototypeOf(IslamicUmalquraCalendar.prototype), "fromJulianDay", this).call(this, jd);
      } else {
        var y = $ab59ff19176390aebd417f116829f2f$var$UMALQURA_YEAR_START - 1;
        var m = 1;
        var d = 1;

        while (d > 0) {
          y++;
          d = days - $ab59ff19176390aebd417f116829f2f$var$umalquraYearStart(y) + 1;
          var yearLength = $ab59ff19176390aebd417f116829f2f$var$umalquraYearLength(y);

          if (d === yearLength) {
            m = 12;
            break;
          } else if (d < yearLength) {
            var monthLength = $ab59ff19176390aebd417f116829f2f$var$umalquraMonthLength(y, m);
            m = 1;

            while (d > monthLength) {
              d -= monthLength;
              m++;
              monthLength = $ab59ff19176390aebd417f116829f2f$var$umalquraMonthLength(y, m);
            }

            break;
          }
        }

        return new CalendarDate(this, y, m, days - $ab59ff19176390aebd417f116829f2f$var$umalquraMonthStart(y, m) + 1);
      }
    }
  }, {
    key: "toJulianDay",
    value: function toJulianDay(date) {
      if (date.year < $ab59ff19176390aebd417f116829f2f$var$UMALQURA_YEAR_START || date.year > $ab59ff19176390aebd417f116829f2f$var$UMALQURA_YEAR_END) {
        return _get(_getPrototypeOf(IslamicUmalquraCalendar.prototype), "toJulianDay", this).call(this, date);
      }

      return $ab59ff19176390aebd417f116829f2f$var$CIVIL_EPOC + $ab59ff19176390aebd417f116829f2f$var$umalquraMonthStart(date.year, date.month) + (date.day - 1);
    }
  }, {
    key: "getDaysInMonth",
    value: function getDaysInMonth(date) {
      if (date.year < $ab59ff19176390aebd417f116829f2f$var$UMALQURA_YEAR_START || date.year > $ab59ff19176390aebd417f116829f2f$var$UMALQURA_YEAR_END) {
        return _get(_getPrototypeOf(IslamicUmalquraCalendar.prototype), "getDaysInMonth", this).call(this, date);
      }

      return $ab59ff19176390aebd417f116829f2f$var$umalquraMonthLength(date.year, date.month);
    }
  }, {
    key: "getDaysInYear",
    value: function getDaysInYear(date) {
      if (date.year < $ab59ff19176390aebd417f116829f2f$var$UMALQURA_YEAR_START || date.year > $ab59ff19176390aebd417f116829f2f$var$UMALQURA_YEAR_END) {
        return _get(_getPrototypeOf(IslamicUmalquraCalendar.prototype), "getDaysInYear", this).call(this, date);
      }

      return $ab59ff19176390aebd417f116829f2f$var$umalquraYearLength(date.year);
    }
  }]);

  return IslamicUmalquraCalendar;
}(IslamicCivilCalendar);
var $e017065a6c5d591a525e617a0d3748f$var$HEBREW_EPOCH = 347997; // Hebrew date calculations are performed in terms of days, hours, and
// "parts" (or halakim), which are 1/1080 of an hour, or 3 1/3 seconds.

var $e017065a6c5d591a525e617a0d3748f$var$HOUR_PARTS = 1080;
var $e017065a6c5d591a525e617a0d3748f$var$DAY_PARTS = 24 * $e017065a6c5d591a525e617a0d3748f$var$HOUR_PARTS; // An approximate value for the length of a lunar month.
// It is used to calculate the approximate year and month of a given
// absolute date.

var $e017065a6c5d591a525e617a0d3748f$var$MONTH_DAYS = 29;
var $e017065a6c5d591a525e617a0d3748f$var$MONTH_FRACT = 12 * $e017065a6c5d591a525e617a0d3748f$var$HOUR_PARTS + 793;
var $e017065a6c5d591a525e617a0d3748f$var$MONTH_PARTS = $e017065a6c5d591a525e617a0d3748f$var$MONTH_DAYS * $e017065a6c5d591a525e617a0d3748f$var$DAY_PARTS + $e017065a6c5d591a525e617a0d3748f$var$MONTH_FRACT;

function $e017065a6c5d591a525e617a0d3748f$var$isLeapYear(year) {
  return $e69ae7432d03ee6ff5aa642daa3d5d3$export$mod(year * 7 + 1, 19) < 7;
} // Test for delay of start of new year and to avoid
// Sunday, Wednesday, and Friday as start of the new year.


function $e017065a6c5d591a525e617a0d3748f$var$hebrewDelay1(year) {
  var months = Math.floor((235 * year - 234) / 19);
  var parts = 12084 + 13753 * months;
  var day = months * 29 + Math.floor(parts / 25920);

  if ($e69ae7432d03ee6ff5aa642daa3d5d3$export$mod(3 * (day + 1), 7) < 3) {
    day += 1;
  }

  return day;
} // Check for delay in start of new year due to length of adjacent years


function $e017065a6c5d591a525e617a0d3748f$var$hebrewDelay2(year) {
  var last = $e017065a6c5d591a525e617a0d3748f$var$hebrewDelay1(year - 1);
  var present = $e017065a6c5d591a525e617a0d3748f$var$hebrewDelay1(year);
  var next = $e017065a6c5d591a525e617a0d3748f$var$hebrewDelay1(year + 1);

  if (next - present === 356) {
    return 2;
  }

  if (present - last === 382) {
    return 1;
  }

  return 0;
}

function $e017065a6c5d591a525e617a0d3748f$var$startOfYear(year) {
  return $e017065a6c5d591a525e617a0d3748f$var$hebrewDelay1(year) + $e017065a6c5d591a525e617a0d3748f$var$hebrewDelay2(year);
}

function $e017065a6c5d591a525e617a0d3748f$var$getDaysInYear(year) {
  return $e017065a6c5d591a525e617a0d3748f$var$startOfYear(year + 1) - $e017065a6c5d591a525e617a0d3748f$var$startOfYear(year);
}

function $e017065a6c5d591a525e617a0d3748f$var$getYearType(year) {
  var yearLength = $e017065a6c5d591a525e617a0d3748f$var$getDaysInYear(year);

  if (yearLength > 380) {
    yearLength -= 30; // Subtract length of leap month.
  }

  switch (yearLength) {
    case 353:
      return 0;
    // deficient

    case 354:
      return 1;
    // normal

    case 355:
      return 2;
    // complete
  }
}

function $e017065a6c5d591a525e617a0d3748f$var$getDaysInMonth(year, month) {
  // Normalize month numbers from 1 - 13, even on non-leap years
  if (month >= 6 && !$e017065a6c5d591a525e617a0d3748f$var$isLeapYear(year)) {
    month++;
  } // First of all, dispose of fixed-length 29 day months


  if (month === 4 || month === 7 || month === 9 || month === 11 || month === 13) {
    return 29;
  }

  var yearType = $e017065a6c5d591a525e617a0d3748f$var$getYearType(year); // If it's Heshvan, days depend on length of year

  if (month === 2) {
    return yearType === 2 ? 30 : 29;
  } // Similarly, Kislev varies with the length of year


  if (month === 3) {
    return yearType === 0 ? 29 : 30;
  } // Adar I only exists in leap years


  if (month === 6) {
    return $e017065a6c5d591a525e617a0d3748f$var$isLeapYear(year) ? 30 : 0;
  }

  return 30;
}

export var HebrewCalendar = /*#__PURE__*/function () {
  function HebrewCalendar() {
    _classCallCheck(this, HebrewCalendar);

    this.identifier = 'hebrew';
  }

  _createClass(HebrewCalendar, [{
    key: "fromJulianDay",
    value: function fromJulianDay(jd) {
      var d = jd - $e017065a6c5d591a525e617a0d3748f$var$HEBREW_EPOCH;
      var m = d * $e017065a6c5d591a525e617a0d3748f$var$DAY_PARTS / $e017065a6c5d591a525e617a0d3748f$var$MONTH_PARTS; // Months (approx)

      var year = Math.floor((19 * m + 234) / 235) + 1; // Years (approx)

      var ys = $e017065a6c5d591a525e617a0d3748f$var$startOfYear(year); // 1st day of year

      var dayOfYear = Math.floor(d - ys); // Because of the postponement rules, it's possible to guess wrong.  Fix it.

      while (dayOfYear < 1) {
        year--;
        ys = $e017065a6c5d591a525e617a0d3748f$var$startOfYear(year);
        dayOfYear = Math.floor(d - ys);
      } // Now figure out which month we're in, and the date within that month


      var month = 1;
      var monthStart = 0;

      while (monthStart < dayOfYear) {
        monthStart += $e017065a6c5d591a525e617a0d3748f$var$getDaysInMonth(year, month);
        month++;
      }

      month--;
      monthStart -= $e017065a6c5d591a525e617a0d3748f$var$getDaysInMonth(year, month);
      var day = dayOfYear - monthStart;
      return new CalendarDate(this, year, month, day);
    }
  }, {
    key: "toJulianDay",
    value: function toJulianDay(date) {
      var jd = $e017065a6c5d591a525e617a0d3748f$var$startOfYear(date.year);

      for (var month = 1; month < date.month; month++) {
        jd += $e017065a6c5d591a525e617a0d3748f$var$getDaysInMonth(date.year, month);
      }

      return jd + date.day + $e017065a6c5d591a525e617a0d3748f$var$HEBREW_EPOCH;
    }
  }, {
    key: "getDaysInMonth",
    value: function getDaysInMonth(date) {
      return $e017065a6c5d591a525e617a0d3748f$var$getDaysInMonth(date.year, date.month);
    }
  }, {
    key: "getMonthsInYear",
    value: function getMonthsInYear(date) {
      return $e017065a6c5d591a525e617a0d3748f$var$isLeapYear(date.year) ? 13 : 12;
    }
  }, {
    key: "getDaysInYear",
    value: function getDaysInYear(date) {
      return $e017065a6c5d591a525e617a0d3748f$var$getDaysInYear(date.year);
    }
  }, {
    key: "getYearsInEra",
    value: function getYearsInEra() {
      return 9999;
    }
  }, {
    key: "getEras",
    value: function getEras() {
      return ['AM'];
    }
  }, {
    key: "balanceYearMonth",
    value: function balanceYearMonth(date, previousDate) {
      // Keep date in the same month when switching between leap years and non leap years
      if (previousDate.year !== date.year) {
        if ($e017065a6c5d591a525e617a0d3748f$var$isLeapYear(previousDate.year) && !$e017065a6c5d591a525e617a0d3748f$var$isLeapYear(date.year) && previousDate.month > 6) {
          date.month--;
        } else if (!$e017065a6c5d591a525e617a0d3748f$var$isLeapYear(previousDate.year) && $e017065a6c5d591a525e617a0d3748f$var$isLeapYear(date.year) && previousDate.month > 6) {
          date.month++;
        }
      }
    }
  }]);

  return HebrewCalendar;
}();
var $c1dd3545d4e7040e53a01795c65c0c3$var$ETHIOPIC_EPOCH = 1723856;
var $c1dd3545d4e7040e53a01795c65c0c3$var$COPTIC_EPOCH = 1824665; // The delta between Amete Alem 1 and Amete Mihret 1
// AA 5501 = AM 1

var $c1dd3545d4e7040e53a01795c65c0c3$var$AMETE_MIHRET_DELTA = 5500;

function $c1dd3545d4e7040e53a01795c65c0c3$var$ceToJulianDay(epoch, year, month, day) {
  return epoch + 365 * year + Math.floor(year / 4) // extra day of leap year
  + 30 * (month - 1) // number of days from months (1 based)
  + day - 1 // number of days for present month (1 based)
  ;
}

function $c1dd3545d4e7040e53a01795c65c0c3$var$julianDayToCE(calendar, epoch, jd) {
  var year = Math.floor(4 * (jd - epoch) / 1461);
  var month = 1 + Math.floor((jd - $c1dd3545d4e7040e53a01795c65c0c3$var$ceToJulianDay(epoch, year, 1, 1)) / 30);
  var day = jd + 1 - $c1dd3545d4e7040e53a01795c65c0c3$var$ceToJulianDay(epoch, year, month, 1);
  return new CalendarDate(calendar, year, month, day);
}

function $c1dd3545d4e7040e53a01795c65c0c3$var$getLeapDay(year) {
  return Math.floor(year % 4 / 3);
}

function $c1dd3545d4e7040e53a01795c65c0c3$var$getDaysInMonth(year, month) {
  // The Ethiopian and Coptic calendars have 13 months, 12 of 30 days each and
  // an intercalary month at the end of the year of 5 or 6 days, depending whether
  // the year is a leap year or not. The Leap Year follows the same rules as the
  // Julian Calendar so that the extra month always has six days in the year before
  // a Julian Leap Year.
  if (month % 13 !== 0) {
    // not intercalary month
    return 30;
  } else {
    // intercalary month 5 days + possible leap day
    return $c1dd3545d4e7040e53a01795c65c0c3$var$getLeapDay(year) + 5;
  }
}

export var EthiopicCalendar = /*#__PURE__*/function () {
  function EthiopicCalendar() {
    _classCallCheck(this, EthiopicCalendar);

    this.identifier = 'ethiopic';
  }

  _createClass(EthiopicCalendar, [{
    key: "fromJulianDay",
    value: function fromJulianDay(jd) {
      var date = $c1dd3545d4e7040e53a01795c65c0c3$var$julianDayToCE(this, $c1dd3545d4e7040e53a01795c65c0c3$var$ETHIOPIC_EPOCH, jd);

      if (date.year > 0) {
        date.era = 'AM';
      } else {
        date.era = 'AA';
        date.year += $c1dd3545d4e7040e53a01795c65c0c3$var$AMETE_MIHRET_DELTA;
      }

      return date;
    }
  }, {
    key: "toJulianDay",
    value: function toJulianDay(date) {
      var year = date.year;

      if (date.era === 'AA') {
        year -= $c1dd3545d4e7040e53a01795c65c0c3$var$AMETE_MIHRET_DELTA;
      }

      return $c1dd3545d4e7040e53a01795c65c0c3$var$ceToJulianDay($c1dd3545d4e7040e53a01795c65c0c3$var$ETHIOPIC_EPOCH, year, date.month, date.day);
    }
  }, {
    key: "getDaysInMonth",
    value: function getDaysInMonth(date) {
      var year = date.year;

      if (date.era === 'AA') {
        year -= $c1dd3545d4e7040e53a01795c65c0c3$var$AMETE_MIHRET_DELTA;
      }

      return $c1dd3545d4e7040e53a01795c65c0c3$var$getDaysInMonth(year, date.month);
    }
  }, {
    key: "getMonthsInYear",
    value: function getMonthsInYear() {
      return 13;
    }
  }, {
    key: "getDaysInYear",
    value: function getDaysInYear(date) {
      return 365 + $c1dd3545d4e7040e53a01795c65c0c3$var$getLeapDay(date.year);
    }
  }, {
    key: "getYearsInEra",
    value: function getYearsInEra() {
      return 9999;
    }
  }, {
    key: "getEras",
    value: function getEras() {
      return ['AA', 'AM'];
    }
  }]);

  return EthiopicCalendar;
}();
export var EthiopicAmeteAlemCalendar = /*#__PURE__*/function (_EthiopicCalendar) {
  _inherits(EthiopicAmeteAlemCalendar, _EthiopicCalendar);

  var _super7 = _createSuper(EthiopicAmeteAlemCalendar);

  function EthiopicAmeteAlemCalendar() {
    var _this7;

    _classCallCheck(this, EthiopicAmeteAlemCalendar);

    _this7 = _super7.apply(this, arguments);
    _this7.identifier = 'ethioaa';
    return _this7;
  } // also known as 'ethiopic-amete-alem' in ICU


  _createClass(EthiopicAmeteAlemCalendar, [{
    key: "fromJulianDay",
    value: function fromJulianDay(jd) {
      var date = $c1dd3545d4e7040e53a01795c65c0c3$var$julianDayToCE(this, $c1dd3545d4e7040e53a01795c65c0c3$var$ETHIOPIC_EPOCH, jd);
      date.era = 'AA';
      date.year += $c1dd3545d4e7040e53a01795c65c0c3$var$AMETE_MIHRET_DELTA;
      return date;
    }
  }, {
    key: "getEras",
    value: function getEras() {
      return ['AA'];
    }
  }]);

  return EthiopicAmeteAlemCalendar;
}(EthiopicCalendar);
export var CopticCalendar = /*#__PURE__*/function (_EthiopicCalendar2) {
  _inherits(CopticCalendar, _EthiopicCalendar2);

  var _super8 = _createSuper(CopticCalendar);

  function CopticCalendar() {
    var _this8;

    _classCallCheck(this, CopticCalendar);

    _this8 = _super8.apply(this, arguments);
    _this8.identifier = 'coptic';
    return _this8;
  }

  _createClass(CopticCalendar, [{
    key: "fromJulianDay",
    value: function fromJulianDay(jd) {
      var date = $c1dd3545d4e7040e53a01795c65c0c3$var$julianDayToCE(this, $c1dd3545d4e7040e53a01795c65c0c3$var$COPTIC_EPOCH, jd);

      if (date.year <= 0) {
        date.era = 'BCE';
        date.year = 1 - date.year;
      } else {
        date.era = 'CE';
      }

      return date;
    }
  }, {
    key: "toJulianDay",
    value: function toJulianDay(date) {
      var year = date.year;

      if (date.era === 'BCE') {
        year = 1 - year;
      }

      return $c1dd3545d4e7040e53a01795c65c0c3$var$ceToJulianDay($c1dd3545d4e7040e53a01795c65c0c3$var$COPTIC_EPOCH, year, date.month, date.day);
    }
  }, {
    key: "getDaysInMonth",
    value: function getDaysInMonth(date) {
      var year = date.year;

      if (date.era === 'BCE') {
        year = 1 - year;
      }

      return $c1dd3545d4e7040e53a01795c65c0c3$var$getDaysInMonth(year, date.month);
    }
  }, {
    key: "getYearsToAdd",
    value: function getYearsToAdd(date, years) {
      return date.era === 'BCE' ? -years : years;
    }
  }, {
    key: "getEras",
    value: function getEras() {
      return ['BCE', 'CE'];
    }
  }]);

  return CopticCalendar;
}(EthiopicCalendar);
export function createCalendar(name) {
  switch (name) {
    case 'buddhist':
      return new BuddhistCalendar();

    case 'ethiopic':
      return new EthiopicCalendar();

    case 'ethioaa':
      return new EthiopicAmeteAlemCalendar();

    case 'coptic':
      return new CopticCalendar();

    case 'hebrew':
      return new HebrewCalendar();

    case 'indian':
      return new IndianCalendar();

    case 'islamic-civil':
      return new IslamicCivilCalendar();

    case 'islamic-tbla':
      return new IslamicTabularCalendar();

    case 'islamic-umalqura':
      return new IslamicUmalquraCalendar();

    case 'japanese':
      return new JapaneseCalendar();

    case 'persian':
      return new PersianCalendar();

    case 'roc':
      return new TaiwanCalendar();

    case 'gregory':
    default:
      return new GregorianCalendar();
  }
}
var $b2616a3826de9be957a1356a9a0$var$formatterCache = new Map();
export var DateFormatter = /*#__PURE__*/function () {
  function DateFormatter(locale, options) {
    _classCallCheck(this, DateFormatter);

    if (options === void 0) {
      options = {};
    }

    this.formatter = void 0;
    this.options = void 0;
    this.resolvedHourCycle = void 0;
    this.formatter = $b2616a3826de9be957a1356a9a0$var$getCachedDateFormatter(locale, options);
    this.options = options;
  }

  _createClass(DateFormatter, [{
    key: "format",
    value: function format(value) {
      return this.formatter.format(value);
    }
  }, {
    key: "formatToParts",
    value: function formatToParts(value) {
      return this.formatter.formatToParts(value);
    }
  }, {
    key: "formatRange",
    value: function formatRange(start, end) {
      // @ts-ignore
      if (typeof this.formatter.formatRange === 'function') {
        // @ts-ignore
        return this.formatter.formatRange(start, end);
      }

      if (end < start) {
        throw new RangeError('End date must be >= start date');
      } // Very basic fallback for old browsers.


      return this.formatter.format(start) + " \u2013 " + this.formatter.format(end);
    }
  }, {
    key: "formatRangeToParts",
    value: function formatRangeToParts(start, end) {
      // @ts-ignore
      if (typeof this.formatter.formatRangeToParts === 'function') {
        // @ts-ignore
        return this.formatter.formatRangeToParts(start, end);
      }

      if (end < start) {
        throw new RangeError('End date must be >= start date');
      }

      var startParts = this.formatter.formatToParts(start);
      var endParts = this.formatter.formatToParts(end);
      return [].concat(_toConsumableArray(startParts.map(function (p) {
        return _babelRuntimeHelpersEsmExtends({}, p, {
          source: 'startRange'
        });
      })), [{
        type: 'literal',
        value: ' – ',
        source: 'shared'
      }], _toConsumableArray(endParts.map(function (p) {
        return _babelRuntimeHelpersEsmExtends({}, p, {
          source: 'endRange'
        });
      })));
    }
  }, {
    key: "resolvedOptions",
    value: function resolvedOptions() {
      var resolvedOptions = this.formatter.resolvedOptions();

      if ($b2616a3826de9be957a1356a9a0$var$hasBuggyResolvedHourCycle()) {
        if (!this.resolvedHourCycle) {
          this.resolvedHourCycle = $b2616a3826de9be957a1356a9a0$var$getResolvedHourCycle(resolvedOptions.locale, this.options);
        }

        resolvedOptions.hourCycle = this.resolvedHourCycle;
        resolvedOptions.hour12 = this.resolvedHourCycle === 'h11' || this.resolvedHourCycle === 'h12';
      }

      return resolvedOptions;
    }
  }]);

  return DateFormatter;
}(); // There are multiple bugs involving the hour12 and hourCycle options in various browser engines.
//   - Chrome [1] (and the ECMA 402 spec [2]) resolve hour12: false in English and other locales to h24 (24:00 - 23:59)
//     rather than h23 (00:00 - 23:59). Same can happen with hour12: true in French, which Chrome resolves to h11 (00:00 - 11:59)
//     rather than h12 (12:00 - 11:59).
//   - WebKit returns an incorrect hourCycle resolved option in the French locale due to incorrect parsing of 'h' literal
//     in the resolved pattern. It also formats incorrectly when specifying the hourCycle option for the same reason. [3]
// [1] https://bugs.chromium.org/p/chromium/issues/detail?id=1045791
// [2] https://github.com/tc39/ecma402/issues/402
// [3] https://bugs.webkit.org/show_bug.cgi?id=229313
// https://github.com/unicode-org/cldr/blob/018b55eff7ceb389c7e3fc44e2f657eae3b10b38/common/supplemental/supplementalData.xml#L4774-L4802

var $b2616a3826de9be957a1356a9a0$var$hour12Preferences = {
  true: {
    // Only Japanese uses the h11 style for 12 hour time. All others use h12.
    ja: 'h11'
  },
  false: {// All locales use h23 for 24 hour time. None use h24.
  }
};

function $b2616a3826de9be957a1356a9a0$var$getCachedDateFormatter(locale, options) {
  if (options === void 0) {
    options = {};
  } // Work around buggy hour12 behavior in Chrome / ECMA 402 spec by using hourCycle instead.
  // Only apply the workaround if the issue is detected, because the hourCycle option is buggy in Safari.


  if (typeof options.hour12 === 'boolean' && $b2616a3826de9be957a1356a9a0$var$hasBuggyHour12Behavior()) {
    options = _babelRuntimeHelpersEsmExtends({}, options);
    var pref = $b2616a3826de9be957a1356a9a0$var$hour12Preferences[String(options.hour12)][locale.split('-')[0]];
    var defaultHourCycle = options.hour12 ? 'h12' : 'h23';
    options.hourCycle = pref != null ? pref : defaultHourCycle;
    delete options.hour12;
  }

  var cacheKey = locale + (options ? Object.entries(options).sort(function (a, b) {
    return a[0] < b[0] ? -1 : 1;
  }).join() : '');

  if ($b2616a3826de9be957a1356a9a0$var$formatterCache.has(cacheKey)) {
    return $b2616a3826de9be957a1356a9a0$var$formatterCache.get(cacheKey);
  }

  var numberFormatter = new Intl.DateTimeFormat(locale, options);
  $b2616a3826de9be957a1356a9a0$var$formatterCache.set(cacheKey, numberFormatter);
  return numberFormatter;
}

var $b2616a3826de9be957a1356a9a0$var$_hasBuggyHour12Behavior = null;

function $b2616a3826de9be957a1356a9a0$var$hasBuggyHour12Behavior() {
  if ($b2616a3826de9be957a1356a9a0$var$_hasBuggyHour12Behavior == null) {
    $b2616a3826de9be957a1356a9a0$var$_hasBuggyHour12Behavior = new Intl.DateTimeFormat('en-US', {
      hour: 'numeric',
      hour12: false
    }).format(new Date(2020, 2, 3, 0)) === '24';
  }

  return $b2616a3826de9be957a1356a9a0$var$_hasBuggyHour12Behavior;
}

var $b2616a3826de9be957a1356a9a0$var$_hasBuggyResolvedHourCycle = null;

function $b2616a3826de9be957a1356a9a0$var$hasBuggyResolvedHourCycle() {
  if ($b2616a3826de9be957a1356a9a0$var$_hasBuggyResolvedHourCycle == null) {
    $b2616a3826de9be957a1356a9a0$var$_hasBuggyResolvedHourCycle = new Intl.DateTimeFormat('fr', {
      hour: 'numeric',
      hour12: false
    }).resolvedOptions().hourCycle === 'h12';
  }

  return $b2616a3826de9be957a1356a9a0$var$_hasBuggyResolvedHourCycle;
}

function $b2616a3826de9be957a1356a9a0$var$getResolvedHourCycle(locale, options) {
  if (!options.timeStyle && !options.hour) {
    return undefined;
  } // Work around buggy results in resolved hourCycle and hour12 options in WebKit.
  // Format the minimum possible hour and maximum possible hour in a day and parse the results.


  locale = locale.replace(/(-u-)?-nu-[a-zA-Z0-9]+/, '');
  locale += (locale.includes('-u-') ? '' : '-u') + '-nu-latn';
  var formatter = $b2616a3826de9be957a1356a9a0$var$getCachedDateFormatter(locale, _babelRuntimeHelpersEsmExtends({}, options, {
    timeZone: undefined // use local timezone

  }));
  var min = parseInt(formatter.formatToParts(new Date(2020, 2, 3, 0)).find(function (p) {
    return p.type === 'hour';
  }).value, 10);
  var max = parseInt(formatter.formatToParts(new Date(2020, 2, 3, 23)).find(function (p) {
    return p.type === 'hour';
  }).value, 10);

  if (min === 0 && max === 23) {
    return 'h23';
  }

  if (min === 24 && max === 23) {
    return 'h24';
  }

  if (min === 0 && max === 11) {
    return 'h11';
  }

  if (min === 12 && max === 11) {
    return 'h12';
  }

  throw new Error('Unexpected hour cycle result');
}